// // // // import React, { useState, useEffect } from "react";
// // // // import './CostCalculator.css';

// // // // const LongMoveCostCalculator = ({ booking }) => {
// // // //   const MOVE_WEIGHT = {
// // // //     studio: 1500,
// // // //     "1br": 2500,
// // // //     "2br": 4000,
// // // //     "3br": 6000,
// // // //     "4br": 8000,
// // // //   };

// // // //   const MOVE_TRUCK = {
// // // //     studio: "16 ft",
// // // //     "1br": "16–20 ft",
// // // //     "2br": "20–22 ft",
// // // //     "3br": "26 ft",
// // // //     "4br": "26+ ft / 5-ton",
// // // //   };

// // // //   const hubs = [
// // // //     { value: "", label: "Select hub…" },
// // // //     { value: "43.6532,-79.3832", label: "Toronto Hub" },
// // // //     { value: "49.2827,-123.1207", label: "Vancouver Hub" },
// // // //     { value: "51.0447,-114.0719", label: "Calgary Hub" },
// // // //     { value: "13.0827,80.2707", label: "Chennai Hub" },
// // // //   ];

// // // //   const moveSizes = [
// // // //     { value: "", label: "Select size…" },
// // // //     { value: "studio", label: "Studio" },
// // // //     { value: "1br", label: "1 Bedroom" },
// // // //     { value: "2br", label: "2 Bedroom" },
// // // //     { value: "3br", label: "3 Bedroom" },
// // // //     { value: "4br", label: "4 Bedroom" },
// // // //   ];

// // // //   const normalizeMoveSize = (moveSize) => {
// // // //     const moveSizeMap = {
// // // //       Studio: "studio",
// // // //       "1 Bedroom": "1br",
// // // //       "2 Bedroom": "2br",
// // // //       "3 Bedroom": "3br",
// // // //       "4 Bedroom": "4br",
// // // //     };
// // // //     return moveSizeMap[moveSize] || moveSize.toLowerCase();
// // // //   };

// // // //   const parseMoveSize = (input) => {
// // // //     if (!input) return { moveSize: "", weight: "" };
// // // //     const match = input.match(/(.*?)(\d+)\s*lbs$/i);
// // // //     if (match) {
// // // //       const rawSize = match[1].trim();
// // // //       const weight = match[2];
// // // //       const normalizedSize = normalizeMoveSize(rawSize);
// // // //       return { moveSize: normalizedSize, weight };
// // // //     } else {
// // // //       return { moveSize: normalizeMoveSize(input), weight: "" };
// // // //     }
// // // //   };

// // // //   const getStaircaseFee = (stairs) => {
// // // //     if (stairs >= 40) return 600;
// // // //     if (stairs >= 30 && stairs < 40) return 450;
// // // //     if (stairs >= 20 && stairs < 30) return 300;
// // // //     if (stairs >= 10 && stairs < 20) return 150;
// // // //     return 0;
// // // //   };

// // // //   const getLongWalkCharges = (yards) => {
// // // //     if (yards >= 150) return 300;
// // // //     if (yards >= 100 && yards < 150) return 250;
// // // //     if (yards >= 50 && yards < 100) return 200;
// // // //     if (yards >= 40 && yards < 50) return 150;
// // // //     return 0;
// // // //   };

// // // //   const [form, setForm] = useState({
// // // //     startingHub: "",
// // // //     moveDate: booking?.Move_Date || "",
// // // //     origin: booking?.FromAddress || booking?.OriginCity || "",
// // // //     destination: booking?.ToAddress || booking?.DestinationCity || "",
// // // //     staircaseFee: "",
// // // //     longWalkCharges: "",
// // // //     stopHub: "",
// // // //     km1: "", // Start → Customer
// // // //     km2: "", // Customer → Start
// // // //     km3: "", // Dest → Customer
// // // //     km4: "", // Customer → Dest
// // // //     origBillTimeHrs: "",
// // // //     origNonBillTimeHrs: "",
// // // //     origLoadTimeHrs: "",
// // // //     origUnloadTimeHrs: "",
// // // //     origLoadTrailerTimeHrs: "",
// // // //     destBillTimeHrs: "",
// // // //     destNonBillTimeHrs: "",
// // // //     destLoadTimeHrs: "",
// // // //     destUnloadTimeHrs: "",
// // // //     destUnloadTrailerTimeHrs: "",
// // // //     origDriverCost: "",
// // // //     origHelpersCost: "",
// // // //     origTotalLabour: "",
// // // //     origTruckCost: "",
// // // //     origFuelCost: "",
// // // //     origSubtotal: "",
// // // //     transTrailerCost: "",
// // // //     transSubtotal: "",
// // // //     destDriverCost: "",
// // // //     destHelpersCost: "",
// // // //     destTotalLabour: "",
// // // //     destTruckCost: "",
// // // //     destFuelCost: "",
// // // //     destSubtotal: "",
// // // //     moveSize: "",
// // // //     estWeightLbs: "",
// // // //     truckSize: "",
// // // //     numMen: "2",
// // // //     truckCost: "200",
// // // //     subTotal: "",
// // // //     leadCost: "0",
// // // //     opsExpense: "0",
// // // //     profitPct: "50",
// // // //     ACVLSplitPct: "50",
// // // //     vendorsplitPct: "50",
// // // //   });

// // // //   const [distanceStatus, setDistanceStatus] = useState(
// // // //     "Enter all locations to fetch distances."
// // // //   );
// // // //   const [totalCost, setTotalCost] = useState(0);
// // // //   const [breakdown, setBreakdown] = useState("");
// // // //   const [apiKey, setApiKey] = useState("");
// // // //   const [isDistanceFetched, setIsDistanceFetched] = useState(false);
// // // //   const [isCalculated, setIsCalculated] = useState(false);
// // // //   const [isFetching, setIsFetching] = useState(false);
// // // //   const [collapsedSections, setCollapsedSections] = useState({
// // // //     jobDetails: false,
// // // //     moveDetails: false,
// // // //     distanceCost: false,
// // // //     results: false,
// // // //   });

// // // //   useEffect(() => {
// // // //     const fetchApiKey = async () => {
// // // //       try {
// // // //         const response = await fetch("https://salesjet-10097049716.catalystappsail.com/api/get-google-api-key");
// // // //         const data = await response.json();
// // // //         setApiKey(data.apiKey);
// // // //       } catch (error) {
// // // //         console.error("Failed to fetch API key:", error);
// // // //         setDistanceStatus("Error fetching API key.");
// // // //       }
// // // //     };

// // // //     fetchApiKey();

// // // //     const { moveSize: normalizedMoveSize, weight } = parseMoveSize(booking?.Move_Size);
// // // //     const totalStairs = parseInt(booking?.NoOfStaircasesAtOrigin || 0) + parseInt(booking?.NoOfStaircasesAtDestination || 0);
// // // //     const staircaseFee = getStaircaseFee(totalStairs);
// // // //     const totalYards = parseFloat(booking?.LongWalkAtOrigin || 0) + parseFloat(booking?.LongWalkAtDestination || 0);
// // // //     const longWalkCharges = getLongWalkCharges(totalYards);
// // // //     const updates = {
// // // //       origin: booking?.FromAddress || booking?.OriginCity || "",
// // // //       destination: booking?.ToAddress || booking?.DestinationCity || "",
// // // //       moveSize: normalizedMoveSize,
// // // //       estWeightLbs: weight || (normalizedMoveSize ? MOVE_WEIGHT[normalizedMoveSize] || "" : ""),
// // // //       truckSize: normalizedMoveSize ? MOVE_TRUCK[normalizedMoveSize] || "" : "",
// // // //       staircaseFee: staircaseFee.toFixed(2),
// // // //       longWalkCharges: longWalkCharges.toFixed(2),
// // // //       origTruckCost: "200",
// // // //       destTruckCost: "200",
// // // //     };
// // // //     setForm((prev) => ({ ...prev, ...updates }));
// // // //     if (normalizedMoveSize || weight) {
// // // //       autoCalculateTimesAndCosts();
// // // //     }
// // // //   }, [booking]);

// // // //   const fmtMoney = (v) =>
// // // //     isFinite(v) ? (v < 0 ? "-$" : "$") + Math.abs(v).toFixed(2) : "$0.00";

// // // //   const updateForm = (updates) => {
// // // //     setForm((prev) => {
// // // //       const newForm = { ...prev, ...updates };
// // // //       if (updates.ACVLSplitPct !== undefined) {
// // // //         newForm.vendorsplitPct = (100 - parseFloat(updates.ACVLSplitPct || 0)).toString();
// // // //       }
// // // //       return newForm;
// // // //     });
// // // //   };

// // // //   const autoCalculateTimesAndCosts = () => {
// // // //     const w = parseFloat(form.estWeightLbs) || 0;
// // // //     const men = Math.max(1, parseInt(form.numMen || 0));
// // // //     const crewFactor = men / 2;
// // // //     const km1 = parseFloat(form.km1) || 0;
// // // //     const km2 = parseFloat(form.km2) || 0;
// // // //     const km3 = parseFloat(form.km3) || 0;
// // // //     const km4 = parseFloat(form.km4) || 0;
// // // //     const truckCost = parseFloat(form.truckCost) || 200;

// // // //     // Origin Side Calculations
// // // //     const origBillTime = km1 / 100;
// // // //     const origNonBillTime = km2 / 100;
// // // //     const origLoadTime = crewFactor > 0 ? w / (650 * crewFactor) : 0;
// // // //     const origUnloadTime = crewFactor > 0 ? w / (850 * crewFactor) : 0;
// // // //     const origLoadTrailerTime = crewFactor > 0 ? w / (650 * crewFactor) : 0;
// // // //     const origDriverCost = (origBillTime + origNonBillTime + origLoadTime + origUnloadTime + origLoadTrailerTime) * 20;
// // // //     const origHelpers = Math.max(0, men - 1);
// // // //     const origHelperPer = (origLoadTime + origUnloadTime + origLoadTrailerTime) * 20 + (origBillTime + origNonBillTime) * 10;
// // // //     const origHelpersCost = origHelpers * origHelperPer;
// // // //     const origTotalLabour = origDriverCost + origHelpersCost;
// // // //     const origFuelCost = ((km1 + km2) / 3.5) * 1.7;
// // // //     const origSubtotal = origTotalLabour + truckCost + origFuelCost;

// // // //     // Transit Calculations
// // // //     const transTrailerCost = w * 0.55;
// // // //     const transSubtotal = transTrailerCost;

// // // //     // Destination Side Calculations
// // // //     const destBillTime = km3 / 100;
// // // //     const destNonBillTime = km4 / 100;
// // // //     const destLoadTime = crewFactor > 0 ? w / (650 * crewFactor) : 0;
// // // //     const destUnloadTime = crewFactor > 0 ? w / (850 * crewFactor) : 0;
// // // //     const destUnloadTrailerTime = crewFactor > 0 ? w / (850 * crewFactor) : 0;
// // // //     const destDriverCost = (destBillTime + destNonBillTime + destLoadTime + destUnloadTime + destUnloadTrailerTime) * 20;
// // // //     const destHelpers = Math.max(0, men - 1);
// // // //     const destHelperPer = (destLoadTime + destUnloadTime + destUnloadTrailerTime) * 20 + (destBillTime + destNonBillTime) * 10;
// // // //     const destHelpersCost = destHelpers * destHelperPer;
// // // //     const destTotalLabour = destDriverCost + destHelpersCost;
// // // //     const destFuelCost = ((km3 + km4) / 3.5) * 1.7;
// // // //     const destSubtotal = destTotalLabour + truckCost + destFuelCost;

// // // //     // Fixed Costs
// // // //     const subTotal = origSubtotal + transSubtotal + destSubtotal + parseFloat(form.staircaseFee || 0) + parseFloat(form.longWalkCharges || 0);
// // // //     const leadCost = subTotal * 0.05;
// // // //     const opsExpense = subTotal * 0.10;

// // // //     updateForm({
// // // //       origBillTimeHrs: origBillTime.toFixed(2),
// // // //       origNonBillTimeHrs: origNonBillTime.toFixed(2),
// // // //       origLoadTimeHrs: origLoadTime.toFixed(2),
// // // //       origUnloadTimeHrs: origUnloadTime.toFixed(2),
// // // //       origLoadTrailerTimeHrs: origLoadTrailerTime.toFixed(2),
// // // //       origDriverCost: origDriverCost.toFixed(2),
// // // //       origHelpersCost: origHelpersCost.toFixed(2),
// // // //       origTotalLabour: origTotalLabour.toFixed(2),
// // // //       origTruckCost: truckCost.toFixed(2),
// // // //       origFuelCost: origFuelCost.toFixed(2),
// // // //       origSubtotal: origSubtotal.toFixed(2),
// // // //       transTrailerCost: transTrailerCost.toFixed(2),
// // // //       transSubtotal: transSubtotal.toFixed(2),
// // // //       destBillTimeHrs: destBillTime.toFixed(2),
// // // //       destNonBillTimeHrs: destNonBillTime.toFixed(2),
// // // //       destLoadTimeHrs: destLoadTime.toFixed(2),
// // // //       destUnloadTimeHrs: destUnloadTime.toFixed(2),
// // // //       destUnloadTrailerTimeHrs: destUnloadTrailerTime.toFixed(2),
// // // //       destDriverCost: destDriverCost.toFixed(2),
// // // //       destHelpersCost: destHelpersCost.toFixed(2),
// // // //       destTotalLabour: destTotalLabour.toFixed(2),
// // // //       destTruckCost: truckCost.toFixed(2),
// // // //       destFuelCost: destFuelCost.toFixed(2),
// // // //       destSubtotal: destSubtotal.toFixed(2),
// // // //       subTotal: subTotal.toFixed(2),
// // // //       leadCost: leadCost.toFixed(2),
// // // //       opsExpense: opsExpense.toFixed(2),
// // // //     });
// // // //   };

// // // //   const fetchDistances = async () => {
// // // //     setDistanceStatus('Looking up distances…');
// // // //     setIsFetching(true);
// // // //     setIsDistanceFetched(false);
// // // //     try {
// // // //       const { startingHub, stopHub, origin, destination } = form;
// // // //       if (!(startingHub && stopHub && origin && destination)) {
// // // //         setDistanceStatus('Please fill Starting Hub, Stop Hub, Origin, and Destination.');
// // // //         setIsFetching(false);
// // // //         return;
// // // //       }

// // // //       const response = await fetch('https://salesjet-10097049716.catalystappsail.com/api/calculate-distances', {
// // // //         method: 'POST',
// // // //         headers: { 'Content-Type': 'application/json' },
// // // //         body: JSON.stringify({ startingHub, stopHub, origin, destination }),
// // // //       });

// // // //       if (!response.ok) {
// // // //         throw new Error('Failed to fetch distances from server.');
// // // //       }

// // // //       const { billableKm, nonBillableKm, durationInHours } = await response.json();
// // // //       const km1 = billableKm / 2; // Assuming split for Start → Customer
// // // //       const km2 = billableKm / 2; // Customer → Start
// // // //       const km3 = nonBillableKm / 2; // Dest → Customer
// // // //       const km4 = nonBillableKm / 2; // Customer → Dest

// // // //       updateForm({
// // // //         km1: km1.toFixed(1),
// // // //         km2: km2.toFixed(1),
// // // //         km3: km3.toFixed(1),
// // // //         km4: km4.toFixed(1),
// // // //       });
// // // //       autoCalculateTimesAndCosts();
// // // //       setIsDistanceFetched(true);
// // // //       setIsCalculated(false);
// // // //       setDistanceStatus(
// // // //         `Updated ✓ Legs: ${km1.toFixed(1)} km, ${km2.toFixed(1)} km, ${km3.toFixed(1)} km, ${km4.toFixed(1)} km (${durationInHours} hrs)`
// // // //       );
// // // //     } catch (err) {
// // // //       console.error(err);
// // // //       setDistanceStatus('Distance lookup failed. Check locations or try again.');
// // // //       setIsDistanceFetched(false);
// // // //     } finally {
// // // //       setIsFetching(false);
// // // //     }
// // // //   };

// // // //   const calculate = (e) => {
// // // //     e.preventDefault();
// // // //     if (isCalculated) {
// // // //       return;
// // // //     }

// // // //     autoCalculateTimesAndCosts();

// // // //     const subTotal = parseFloat(form.subTotal) || 0;
// // // //     const lead = parseFloat(form.leadCost) || 0;
// // // //     const ops = parseFloat(form.opsExpense) || 0;
// // // //     const profitPct = (parseFloat(form.profitPct) || 0) / 100;
// // // //     const acvlSplitPct = (parseFloat(form.ACVLSplitPct) || 0) / 100;
// // // //     const vendorSplitPct = (parseFloat(form.vendorsplitPct) || 0) / 100;
// // // //     const profitBase = subTotal + lead + ops;
// // // //     const profit = profitBase * profitPct;
// // // //     const total = profitBase + profit;
// // // //     const acvlProfit = profit * acvlSplitPct;
// // // //     const vendorProfit = profit * vendorSplitPct;

// // // //     setTotalCost(total);
// // // //     setBreakdown(
// // // //       `Origin Side:
// // // //   Billable Travel Time: ${form.origBillTimeHrs || 0} hrs
// // // //   Non-Billable Travel Time: ${form.origNonBillTimeHrs || 0} hrs
// // // //   Loading: ${form.origLoadTimeHrs || 0} hrs
// // // //   Unloading: ${form.origUnloadTimeHrs || 0} hrs
// // // //   Loading into Trailer: ${form.origLoadTrailerTimeHrs || 0} hrs
// // // //   Driver: ${fmtMoney(parseFloat(form.origDriverCost) || 0)}
// // // //   Helpers: ${fmtMoney(parseFloat(form.origHelpersCost) || 0)}
// // // //   Truck: ${fmtMoney(parseFloat(form.origTruckCost) || 0)}
// // // //   Fuel: ${fmtMoney(parseFloat(form.origFuelCost) || 0)}
// // // //   Subtotal (Origin): ${fmtMoney(parseFloat(form.origSubtotal) || 0)}
// // // // Transit:
// // // //   Trailer Transit: ${fmtMoney(parseFloat(form.transTrailerCost) || 0)}
// // // //   Subtotal (Transit): ${fmtMoney(parseFloat(form.transSubtotal) || 0)}
// // // // Destination Side:
// // // //   Billable Travel Time: ${form.destBillTimeHrs || 0} hrs
// // // //   Non-Billable Travel Time: ${form.destNonBillTimeHrs || 0} hrs
// // // //   Loading: ${form.destLoadTimeHrs || 0} hrs
// // // //   Unloading: ${form.destUnloadTimeHrs || 0} hrs
// // // //   Unloading from Trailer: ${form.destUnloadTrailerTimeHrs || 0} hrs
// // // //   Driver: ${fmtMoney(parseFloat(form.destDriverCost) || 0)}
// // // //   Helpers: ${fmtMoney(parseFloat(form.destHelpersCost) || 0)}
// // // //   Truck: ${fmtMoney(parseFloat(form.destTruckCost) || 0)}
// // // //   Fuel: ${fmtMoney(parseFloat(form.destFuelCost) || 0)}
// // // //   Subtotal (Dest): ${fmtMoney(parseFloat(form.destSubtotal) || 0)}
// // // // Totals:
// // // //   Local Labour (Origin+Dest): ${fmtMoney((parseFloat(form.origTotalLabour) || 0) + (parseFloat(form.destTotalLabour) || 0))}
// // // //   Total Fuel: ${fmtMoney((parseFloat(form.origFuelCost) || 0) + (parseFloat(form.destFuelCost) || 0))}
// // // //   Trailer Transit: ${fmtMoney(parseFloat(form.transTrailerCost) || 0)}
// // // //   Stairs: ${fmtMoney(parseFloat(form.staircaseFee) || 0)}
// // // //   Long Walk: ${fmtMoney(parseFloat(form.longWalkCharges) || 0)}
// // // //   SubTotal: ${fmtMoney(subTotal)}
// // // //   Lead (5%): ${fmtMoney(lead)}
// // // //   Ops (10%): ${fmtMoney(ops)}
// // // //   Profit (${form.profitPct || 0}%): ${fmtMoney(profit)}
// // // //     ACVL (${form.ACVLSplitPct || 0}%): ${fmtMoney(acvlProfit)}
// // // //     Vendor (${form.vendorsplitPct || 0}%): ${fmtMoney(vendorProfit)}
// // // // Grand Total: ${fmtMoney(total)}`
// // // //     );
// // // //     setIsCalculated(true);
// // // //   };

// // // //   const reset = () => {
// // // //     setForm({
// // // //       startingHub: "",
// // // //       moveDate: booking?.Move_Date || "",
// // // //       origin: booking?.FromAddress || booking?.OriginCity || "",
// // // //       destination: booking?.ToAddress || booking?.DestinationCity || "",
// // // //       stopHub: "",
// // // //       km1: "",
// // // //       km2: "",
// // // //       km3: "",
// // // //       km4: "",
// // // //       origBillTimeHrs: "",
// // // //       origNonBillTimeHrs: "",
// // // //       origLoadTimeHrs: "",
// // // //       origUnloadTimeHrs: "",
// // // //       origLoadTrailerTimeHrs: "",
// // // //       destBillTimeHrs: "",
// // // //       destNonBillTimeHrs: "",
// // // //       destLoadTimeHrs: "",
// // // //       destUnloadTimeHrs: "",
// // // //       destUnloadTrailerTimeHrs: "",
// // // //       origDriverCost: "",
// // // //       origHelpersCost: "",
// // // //       origTotalLabour: "",
// // // //       origTruckCost: "200",
// // // //       origFuelCost: "",
// // // //       origSubtotal: "",
// // // //       transTrailerCost: "",
// // // //       transSubtotal: "",
// // // //       destDriverCost: "",
// // // //       destHelpersCost: "",
// // // //       destTotalLabour: "",
// // // //       destTruckCost: "200",
// // // //       destFuelCost: "",
// // // //       destSubtotal: "",
// // // //       moveSize: "",
// // // //       estWeightLbs: "",
// // // //       truckSize: "",
// // // //       numMen: "2",
// // // //       truckCost: "200",
// // // //       subTotal: "",
// // // //       leadCost: "0",
// // // //       opsExpense: "0",
// // // //       profitPct: "50",
// // // //       ACVLSplitPct: "50",
// // // //       vendorsplitPct: "50",
// // // //       staircaseFee: "",
// // // //       longWalkCharges: "",
// // // //     });
// // // //     setDistanceStatus("Enter all locations to fetch distances.");
// // // //     setTotalCost(0);
// // // //     setBreakdown("");
// // // //     setIsDistanceFetched(false);
// // // //     setIsFetching(false);
// // // //     setIsCalculated(false);
// // // //     setCollapsedSections({
// // // //       jobDetails: false,
// // // //       moveDetails: false,
// // // //       distanceCost: false,
// // // //       results: false,
// // // //     });
// // // //   };

// // // //   const toggleSection = (section) => {
// // // //     setCollapsedSections((prev) => ({
// // // //       ...prev,
// // // //       [section]: !prev[section],
// // // //     }));
// // // //   };

// // // //   const SelectField = ({ id, label, options, hint, onChange }) => (
// // // //     <div>
// // // //       <label htmlFor={id}>{label}</label>
// // // //       <select
// // // //         id={id}
// // // //         value={form[id] || ""}
// // // //         onChange={onChange || ((e) => updateForm({ [id]: e.target.value }))}
// // // //       >
// // // //         {options.map((opt) => (
// // // //           <option key={opt.value} value={opt.value}>{opt.label}</option>
// // // //         ))}
// // // //       </select>
// // // //       {hint && <div className="cost_hint">{hint}</div>}
// // // //     </div>
// // // //   );

// // // //   const ComboField = ({ id, label, options, hint }) => (
// // // //     <div>
// // // //       <label htmlFor={id}>{label}</label>
// // // //       <input
// // // //         id={id}
// // // //         type="text"
// // // //         list={`${id}-datalist`}
// // // //         value={form[id] || ""}
// // // //         onChange={(e) => updateForm({ [id]: e.target.value })}
// // // //         placeholder="Type location or select hub..."
// // // //       />
// // // //       <datalist id={`${id}-datalist`}>
// // // //         {options.map((opt) => (
// // // //           <option key={opt.value} value={opt.value}>
// // // //             {opt.label}
// // // //           </option>
// // // //         ))}
// // // //       </datalist>
// // // //       {hint && <div className="cost_hint">{hint}</div>}
// // // //     </div>
// // // //   );

// // // //   return (
// // // //     <div className="cost_wrap">
// // // //       <main className="cost_wrap">
// // // //         <section className="cost_card">
// // // //           <div className="cost_row" style={{ justifyContent: "space-between" }}>
// // // //             <h2 style={{ margin: 0, fontSize: "1.05rem" }}>Job Details</h2>
// // // //             <div style={{ display: "flex", alignItems: "center" }}>
// // // //               <span className="cost_pill">All distances in KM • Time rule: 100km ≈ 1hr</span>
// // // //               <button
// // // //                 onClick={() => toggleSection("jobDetails")}
// // // //                 style={{
// // // //                   marginLeft: "10px",
// // // //                   fontSize: "1.2rem",
// // // //                   cursor: "pointer",
// // // //                   color: "#333",
// // // //                   border: "none",
// // // //                   background: "none",
// // // //                 }}
// // // //               >
// // // //                 {collapsedSections.jobDetails ? "+" : "−"}
// // // //               </button>
// // // //             </div>
// // // //           </div>
// // // //           <div className="cost_bar"></div>
// // // //           {!collapsedSections.jobDetails && (
// // // //             <div className="cost_grid cost_cols-3">
// // // //               <div>
// // // //                 <label htmlFor="origin">Origin (City, Province)</label>
// // // //                 <div className="cost_unit">
// // // //                   <input
// // // //                     id="origin"
// // // //                     type="text"
// // // //                     placeholder="City, ST, Country or lat,lon"
// // // //                     value={form.origin || ""}
// // // //                     onChange={(e) => updateForm({ origin: e.target.value })}
// // // //                     readOnly
// // // //                   />
// // // //                 </div>
// // // //               </div>
// // // //               <div>
// // // //                 <label htmlFor="destination">Destination (City, Province)</label>
// // // //                 <div className="cost_unit">
// // // //                   <input
// // // //                     id="destination"
// // // //                     type="text"
// // // //                     placeholder="City, ST, Country or lat,lon"
// // // //                     value={form.destination || ""}
// // // //                     onChange={(e) => updateForm({ destination: e.target.value })}
// // // //                     readOnly
// // // //                   />
// // // //                 </div>
// // // //               </div>
// // // //               <div>
// // // //                 <label htmlFor="moveDate">Move Date</label>
// // // //                 <div className="cost_unit">
// // // //                   <input
// // // //                     id="moveDate"
// // // //                     type="text"
// // // //                     placeholder="YYYY-MM-DD"
// // // //                     value={form.moveDate || ""}
// // // //                     onChange={(e) => updateForm({ moveDate: e.target.value })}
// // // //                     readOnly
// // // //                   />
// // // //                 </div>
// // // //               </div>
// // // //               <div>
// // // //                 <label htmlFor="moveSize">Move Size (Bedrooms)</label>
// // // //                 <div className="cost_unit">
// // // //                   <input
// // // //                     id="moveSize"
// // // //                     type="text"
// // // //                     placeholder="Select size…"
// // // //                     value={moveSizes.find(opt => opt.value === form.moveSize)?.label || form.moveSize || ""}
// // // //                     readOnly
// // // //                   />
// // // //                 </div>
// // // //               </div>
// // // //             </div>
// // // //           )}
// // // //         </section>

// // // //         <section className="cost_card">
// // // //           <div className="cost_row" style={{ justifyContent: "space-between" }}>
// // // //             <h2 style={{ margin: 0, fontSize: "1.05rem" }}>Move Details & Profit Range</h2>
// // // //             <button
// // // //               onClick={() => toggleSection("moveDetails")}
// // // //               style={{
// // // //                 fontSize: "1.2rem",
// // // //                 cursor: "pointer",
// // // //                 color: "#333",
// // // //                 border: "none",
// // // //                 background: "none",
// // // //               }}
// // // //             >
// // // //               {collapsedSections.moveDetails ? "+" : "−"}
// // // //             </button>
// // // //           </div>
// // // //           <div className="cost_bar"></div>
// // // //           {!collapsedSections.moveDetails && (
// // // //             <>
// // // //               <div className="cost_grid cost_cols-3">
// // // //                 <ComboField
// // // //                   id="startingHub"
// // // //                   label="Starting Location (Hub)"
// // // //                   options={hubs}
// // // //                 />
// // // //                 <ComboField
// // // //                   id="stopHub"
// // // //                   label="Stop Location (Hub)"
// // // //                   options={hubs}
// // // //                 />
// // // //               </div>
// // // //               <div className="cost_btns" style={{ marginTop: "8px", position: "relative" }}>
// // // //                 <button
// // // //                   type="button"
// // // //                   onClick={fetchDistances}
// // // //                   className={isDistanceFetched ? "cost_fetched" : isFetching ? "cost_fetching" : ""}
// // // //                 >
// // // //                   Fetch distances online (Google Maps)
// // // //                   {isFetching && (
// // // //                     <span className="spinner" style={{ marginLeft: "8px" }}>↻</span>
// // // //                   )}
// // // //                 </button>
// // // //               </div>
// // // //               <div className="cost_grid cost_cols-3" style={{ marginTop: "10px" }}>
// // // //                 <div>
// // // //                   <label htmlFor="estWeightLbs">Estimated Weight</label>
// // // //                   <div className="cost_unit">
// // // //                     <input
// // // //                       id="estWeightLbs"
// // // //                       type="number"
// // // //                       min="0"
// // // //                       step="1"
// // // //                       placeholder="0"
// // // //                       value={form.estWeightLbs || ""}
// // // //                       onChange={(e) => {
// // // //                         updateForm({ estWeightLbs: e.target.value });
// // // //                         autoCalculateTimesAndCosts();
// // // //                         setIsCalculated(false);
// // // //                       }}
// // // //                     />
// // // //                     <span>lbs</span>
// // // //                   </div>
// // // //                 </div>
// // // //                 <div>
// // // //                   <label htmlFor="truckSize">Truck Size</label>
// // // //                   <div className="cost_unit">
// // // //                     <input
// // // //                       id="truckSize"
// // // //                       type="text"
// // // //                       placeholder="e.g., 16 ft / 20 ft / 26 ft"
// // // //                       value={form.truckSize || ""}
// // // //                       onChange={(e) => updateForm({ truckSize: e.target.value })}
// // // //                     />
// // // //                   </div>
// // // //                 </div>
// // // //                 <div>
// // // //                   <label htmlFor="numMen">Number of Men</label>
// // // //                   <div className="cost_unit">
// // // //                     <input
// // // //                       id="numMen"
// // // //                       type="number"
// // // //                       min="1"
// // // //                       step="1"
// // // //                       placeholder="2"
// // // //                       value={form.numMen || ""}
// // // //                       onChange={(e) => {
// // // //                         updateForm({ numMen: e.target.value });
// // // //                         autoCalculateTimesAndCosts();
// // // //                         setIsCalculated(false);
// // // //                       }}
// // // //                     />
// // // //                   </div>
// // // //                 </div>
// // // //                 <div>
// // // //                   <label htmlFor="truckCost">Truck Cost</label>
// // // //                   <div className="cost_unit">
// // // //                     <input
// // // //                       id="truckCost"
// // // //                       type="number"
// // // //                       min="0"
// // // //                       step="0.01"
// // // //                       placeholder="200"
// // // //                       value={form.truckCost || ""}
// // // //                       onChange={(e) => {
// // // //                         updateForm({ truckCost: e.target.value, origTruckCost: e.target.value, destTruckCost: e.target.value });
// // // //                         autoCalculateTimesAndCosts();
// // // //                         setIsCalculated(false);
// // // //                       }}
// // // //                     />
// // // //                     <span>$</span>
// // // //                   </div>
// // // //                   <div className="cost_hint">Enter truck rental or usage cost manually.</div>
// // // //                 </div>
// // // //                 <div>
// // // //                   <label htmlFor="profitPct">Profit Percentage</label>
// // // //                   <div className="cost_unit">
// // // //                     <input
// // // //                       id="profitPct"
// // // //                       type="number"
// // // //                       min="0"
// // // //                       step="0.1"
// // // //                       placeholder="50"
// // // //                       value={form.profitPct || ""}
// // // //                       onChange={(e) => {
// // // //                         updateForm({ profitPct: e.target.value });
// // // //                         setIsCalculated(false);
// // // //                       }}
// // // //                     />
// // // //                     <span>%</span>
// // // //                   </div>
// // // //                   <div className="cost_hint">Applied to (Sub-Total + Lead + Ops)</div>
// // // //                 </div>
// // // //                 <div>
// // // //                   <label htmlFor="ACVLSplitPct">ACVL Profit Split</label>
// // // //                   <div className="cost_unit">
// // // //                     <input
// // // //                       id="ACVLSplitPct"
// // // //                       type="number"
// // // //                       min="0"
// // // //                       max="100"
// // // //                       step="0.1"
// // // //                       placeholder="50"
// // // //                       value={form.ACVLSplitPct || ""}
// // // //                       onChange={(e) => {
// // // //                         updateForm({ ACVLSplitPct: e.target.value });
// // // //                         setIsCalculated(false);
// // // //                       }}
// // // //                     />
// // // //                     <span>%</span>
// // // //                   </div>
// // // //                 </div>
// // // //                 <div>
// // // //                   <label htmlFor="vendorsplitPct">Vendor Profit Split</label>
// // // //                   <div className="cost_unit">
// // // //                     <input
// // // //                       id="vendorsplitPct"
// // // //                       type="number"
// // // //                       min="0"
// // // //                       max="100"
// // // //                       step="0.1"
// // // //                       placeholder="50"
// // // //                       value={form.vendorsplitPct || ""}
// // // //                       readOnly
// // // //                     />
// // // //                     <span>%</span>
// // // //                   </div>
// // // //                 </div>
// // // //               </div>
// // // //             </>
// // // //           )}
// // // //         </section>

// // // //         <section className="cost_card">
// // // //           <div className="cost_row" style={{ justifyContent: "space-between" }}>
// // // //             <h2 style={{ margin: 0, fontSize: "1.05rem" }}>Detailed Cost Breakdown</h2>
// // // //             <button
// // // //               onClick={() => toggleSection("distanceCost")}
// // // //               style={{
// // // //                 fontSize: "1.2rem",
// // // //                 cursor: "pointer",
// // // //                 border: "none",
// // // //                 color: "#333",
// // // //                 background: "none",
// // // //               }}
// // // //             >
// // // //               {collapsedSections.distanceCost ? "+" : "−"}
// // // //             </button>
// // // //           </div>
// // // //           <div className="cost_bar"></div>
// // // //           {!collapsedSections.distanceCost && (
// // // //             <div>
// // // //               {/* Origin Side */}
// // // //               <div style={{ marginBottom: "12px" }}>
// // // //                 <h5 style={{ margin: "0.2rem 0" }}>Origin Side Cost</h5>
// // // //                         <div className="cost_bar"></div>
// // // //                 <div className="cost_grid cost_cols-3">
// // // //                   <div>
// // // //                     <label htmlFor="km1">Start → Customer (km)</label>
// // // //                     <div className="cost_unit">
// // // //                       <input
// // // //                         id="km1"
// // // //                         type="number"
// // // //                         min="0"
// // // //                         step="0.1"
// // // //                         placeholder="0"
// // // //                         value={form.km1 || ""}
// // // //                         onChange={(e) => {
// // // //                           updateForm({ km1: e.target.value });
// // // //                           autoCalculateTimesAndCosts();
// // // //                           setIsCalculated(false);
// // // //                         }}
// // // //                       />
// // // //                       <span>km</span>
// // // //                     </div>
// // // //                   </div>
// // // //                   <div>
// // // //                     <label htmlFor="km2">Customer → Start (km)</label>
// // // //                     <div className="cost_unit">
// // // //                       <input
// // // //                         id="km2"
// // // //                         type="number"
// // // //                         min="0"
// // // //                         step="0.1"
// // // //                         placeholder="0"
// // // //                         value={form.km2 || ""}
// // // //                         onChange={(e) => {
// // // //                           updateForm({ km2: e.target.value });
// // // //                           autoCalculateTimesAndCosts();
// // // //                           setIsCalculated(false);
// // // //                         }}
// // // //                       />
// // // //                       <span>km</span>
// // // //                     </div>
// // // //                   </div>
// // // //                   <div>
// // // //                     <label htmlFor="origBillTimeHrs">Billable Travel Time</label>
// // // //                     <div className="cost_unit">
// // // //                       <input
// // // //                         id="origBillTimeHrs"
// // // //                         type="number"
// // // //                         min="0"
// // // //                         step="0.01"
// // // //                         placeholder="0"
// // // //                         value={form.origBillTimeHrs || ""}
// // // //                         readOnly
// // // //                       />
// // // //                       <span>hrs</span>
// // // //                     </div>
// // // //                     <div className="cost_hint">Formula: Start→Customer km / 100</div>
// // // //                   </div>
// // // //                   <div>
// // // //                     <label htmlFor="origNonBillTimeHrs">Non-Billable Travel Time</label>
// // // //                     <div className="cost_unit">
// // // //                       <input
// // // //                         id="origNonBillTimeHrs"
// // // //                         type="number"
// // // //                         min="0"
// // // //                         step="0.01"
// // // //                         placeholder="0"
// // // //                         value={form.origNonBillTimeHrs || ""}
// // // //                         readOnly
// // // //                       />
// // // //                       <span>hrs</span>
// // // //                     </div>
// // // //                     <div className="cost_hint">Formula: Customer→Start km / 100</div>
// // // //                   </div>
// // // //                   <div>
// // // //                     <label htmlFor="origLoadTimeHrs">Loading Time</label>
// // // //                     <div className="cost_unit">
// // // //                       <input
// // // //                         id="origLoadTimeHrs"
// // // //                         type="number"
// // // //                         min="0"
// // // //                         step="0.01"
// // // //                         placeholder="0"
// // // //                         value={form.origLoadTimeHrs || ""}
// // // //                         readOnly
// // // //                       />
// // // //                       <span>hrs</span>
// // // //                     </div>
// // // //                     <div className="cost_hint">Capacity baseline: 650 lbs/hr by 2 men (scaled)</div>
// // // //                   </div>
// // // //                   <div>
// // // //                     <label htmlFor="origUnloadTimeHrs">Unloading Time</label>
// // // //                     <div className="cost_unit">
// // // //                       <input
// // // //                         id="origUnloadTimeHrs"
// // // //                         type="number"
// // // //                         min="0"
// // // //                         step="0.01"
// // // //                         placeholder="0"
// // // //                         value={form.origUnloadTimeHrs || ""}
// // // //                         readOnly
// // // //                       />
// // // //                       <span>hrs</span>
// // // //                     </div>
// // // //                     <div className="cost_hint">Capacity baseline: 850 lbs/hr by 2 men (scaled)</div>
// // // //                   </div>
// // // //                   <div>
// // // //                     <label htmlFor="origLoadTrailerTimeHrs">Loading Time (into Trailer)</label>
// // // //                     <div className="cost_unit">
// // // //                       <input
// // // //                         id="origLoadTrailerTimeHrs"
// // // //                         type="number"
// // // //                         min="0"
// // // //                         step="0.01"
// // // //                         placeholder="0"
// // // //                         value={form.origLoadTrailerTimeHrs || ""}
// // // //                         readOnly
// // // //                       />
// // // //                       <span>hrs</span>
// // // //                     </div>
// // // //                     <div className="cost_hint">Additional load at Origin Hub into trailer</div>
// // // //                   </div>
// // // //                   <div>
// // // //                     <label htmlFor="origDriverCost">Driver Cost</label>
// // // //                     <div className="cost_unit">
// // // //                       <input
// // // //                         id="origDriverCost"
// // // //                         type="number"
// // // //                         min="0"
// // // //                         step="0.01"
// // // //                         placeholder="0"
// // // //                         value={form.origDriverCost || ""}
// // // //                         readOnly
// // // //                       />
// // // //                       <span>$</span>
// // // //                     </div>
// // // //                     <div className="cost_hint">(Billable + Non-billable + Load + Unload + Load into Trailer) × $20</div>
// // // //                   </div>
// // // //                   <div>
// // // //                     <label htmlFor="origHelpersCost">Helpers Cost</label>
// // // //                     <div className="cost_unit">
// // // //                       <input
// // // //                         id="origHelpersCost"
// // // //                         type="number"
// // // //                         min="0"
// // // //                         step="0.01"
// // // //                         placeholder="0"
// // // //                         value={form.origHelpersCost || ""}
// // // //                         readOnly
// // // //                       />
// // // //                       <span>$</span>
// // // //                     </div>
// // // //                     <div className="cost_hint">Per helper: ((All load/unload) × $20 + (Travel × $10)) × helpers</div>
// // // //                   </div>
// // // //                   <div>
// // // //                     <label htmlFor="origTotalLabour">Total Labour Cost</label>
// // // //                     <div className="cost_unit">
// // // //                       <input
// // // //                         id="origTotalLabour"
// // // //                         type="number"
// // // //                         min="0"
// // // //                         step="0.01"
// // // //                         placeholder="0"
// // // //                         value={form.origTotalLabour || ""}
// // // //                         readOnly
// // // //                       />
// // // //                       <span>$</span>
// // // //                     </div>
// // // //                   </div>
// // // //                   <div>
// // // //                     <label htmlFor="origTruckCost">Truck Cost</label>
// // // //                     <div className="cost_unit">
// // // //                       <input
// // // //                         id="origTruckCost"
// // // //                         type="number"
// // // //                         min="0"
// // // //                         step="0.01"
// // // //                         placeholder="0"
// // // //                         value={form.origTruckCost || ""}
// // // //                         readOnly
// // // //                       />
// // // //                       <span>$</span>
// // // //                     </div>
// // // //                     <div className="cost_hint">From Truck Cost above</div>
// // // //                   </div>
// // // //                   <div>
// // // //                     <label htmlFor="origFuelCost">Fuel Cost (Origin)</label>
// // // //                     <div className="cost_unit">
// // // //                       <input
// // // //                         id="origFuelCost"
// // // //                         type="number"
// // // //                         min="0"
// // // //                         step="0.01"
// // // //                         placeholder="0"
// // // //                         value={form.origFuelCost || ""}
// // // //                         readOnly
// // // //                       />
// // // //                       <span>$</span>
// // // //                     </div>
// // // //                     <div className="cost_hint">Formula: ((Start→Customer + Customer→Start) ÷ 3.5) × 1.7</div>
// // // //                   </div>
// // // //                   <div>
// // // //                     <label htmlFor="origSubtotal">Subtotal (Origin Side)</label>
// // // //                     <div className="cost_unit">
// // // //                       <input
// // // //                         id="origSubtotal"
// // // //                         type="number"
// // // //                         min="0"
// // // //                         step="0.01"
// // // //                         placeholder="0"
// // // //                         value={form.origSubtotal || ""}
// // // //                         readOnly
// // // //                       />
// // // //                       <span>$</span>
// // // //                     </div>
// // // //                   </div>
// // // //                 </div>
// // // //               </div>

// // // //               {/* Transit */}
// // // //               <div style={{ marginBottom: "12px" }}>
// // // //                 <h5 style={{ margin: "0.2rem 0" }}>Transit</h5>
// // // //                 <div className="cost_bar"></div>
// // // //                 <div className="cost_grid cost_cols-3">
// // // //                   <div>
// // // //                     <label htmlFor="transTrailerCost">Trailer Transit Cost</label>
// // // //                     <div className="cost_unit">
// // // //                       <input
// // // //                         id="transTrailerCost"
// // // //                         type="number"
// // // //                         min="0"
// // // //                         step="0.01"
// // // //                         placeholder="0"
// // // //                         value={form.transTrailerCost || ""}
// // // //                         readOnly
// // // //                       />
// // // //                       <span>$</span>
// // // //                     </div>
// // // //                     <div className="cost_hint">Formula: Weight (lbs) × 0.55</div>
// // // //                   </div>
// // // //                   <div>
// // // //                     <label htmlFor="transSubtotal">Transit Subtotal</label>
// // // //                     <div className = "cost_unit">
// // // //                       <input
// // // //                         id="transSubtotal"
// // // //                         type="number"
// // // //                         min="0"
// // // //                         step="0.01"
// // // //                         placeholder="0"
// // // //                         value={form.transSubtotal || ""}
// // // //                         readOnly
// // // //                       />
// // // //                       <span>$</span>
// // // //                     </div>
// // // //                   </div>
// // // //                 </div>
// // // //               </div>

// // // //               {/* Destination Side */}
// // // //               <div>
// // // //                 <h5 style={{ margin: "0.2rem 0" }}>Destination Side Cost</h5>
// // // //                 <div className="cost_bar"></div>
// // // //                 <div className="cost_grid cost_cols-3">
// // // //                   <div>
// // // //                     <label htmlFor="km3">Dest → Customer (km)</label>
// // // //                     <div className="cost_unit">
// // // //                       <input
// // // //                         id="km3"
// // // //                         type="number"
// // // //                         min="0"
// // // //                         step="0.1"
// // // //                         placeholder="0"
// // // //                         value={form.km3 || ""}
// // // //                         onChange={(e) => {
// // // //                           updateForm({ km3: e.target.value });
// // // //                           autoCalculateTimesAndCosts();
// // // //                           setIsCalculated(false);
// // // //                         }}
// // // //                       />
// // // //                       <span>km</span>
// // // //                     </div>
// // // //                   </div>
// // // //                   <div>
// // // //                     <label htmlFor="km4">Customer → Dest (km)</label>
// // // //                     <div className="cost_unit">
// // // //                       <input
// // // //                         id="km4"
// // // //                         type="number"
// // // //                         min="0"
// // // //                         step="0.1"
// // // //                         placeholder="0"
// // // //                         value={form.km4 || ""}
// // // //                         onChange={(e) => {
// // // //                           updateForm({ km4: e.target.value });
// // // //                           autoCalculateTimesAndCosts();
// // // //                           setIsCalculated(false);
// // // //                         }}
// // // //                       />
// // // //                       <span>km</span>
// // // //                     </div>
// // // //                   </div>
// // // //                   <div>
// // // //                     <label htmlFor="destBillTimeHrs">Billable Travel Time</label>
// // // //                     <div className="cost_unit">
// // // //                       <input
// // // //                         id="destBillTimeHrs"
// // // //                         type="number"
// // // //                         min="0"
// // // //                         step="0.01"
// // // //                         placeholder="0"
// // // //                         value={form.destBillTimeHrs || ""}
// // // //                         readOnly
// // // //                       />
// // // //                       <span>hrs</span>
// // // //                     </div>
// // // //                     <div className="cost_hint">Formula: Dest→Customer km / 100</div>
// // // //                   </div>
// // // //                   <div>
// // // //                     <label htmlFor="destNonBillTimeHrs">Non-Billable Travel Time</label>
// // // //                     <div className="cost_unit">
// // // //                       <input
// // // //                         id="destNonBillTimeHrs"
// // // //                         type="number"
// // // //                         min="0"
// // // //                         step="0.01"
// // // //                         placeholder="0"
// // // //                         value={form.destNonBillTimeHrs || ""}
// // // //                         readOnly
// // // //                       />
// // // //                       <span>hrs</span>
// // // //                     </div>
// // // //                     <div className="cost_hint">Formula: Customer→Dest km / 100</div>
// // // //                   </div>
// // // //                   <div>
// // // //                     <label htmlFor="destLoadTimeHrs">Loading Time</label>
// // // //                     <div className="cost_unit">
// // // //                       <input
// // // //                         id="destLoadTimeHrs"
// // // //                         type="number"
// // // //                         min="0"
// // // //                         step="0.01"
// // // //                         placeholder="0"
// // // //                         value={form.destLoadTimeHrs || ""}
// // // //                         readOnly
// // // //                       />
// // // //                       <span>hrs</span>
// // // //                     </div>
// // // //                     <div className="cost_hint">Capacity baseline: 650 lbs/hr by 2 men (scaled)</div>
// // // //                   </div>
// // // //                   <div>
// // // //                     <label htmlFor="destUnloadTimeHrs">Unloading Time</label>
// // // //                     <div className="cost_unit">
// // // //                       <input
// // // //                         id="destUnloadTimeHrs"
// // // //                         type="number"
// // // //                         min="0"
// // // //                         step="0.01"
// // // //                         placeholder="0"
// // // //                         value={form.destUnloadTimeHrs || ""}
// // // //                         readOnly
// // // //                       />
// // // //                       <span>hrs</span>
// // // //                     </div>
// // // //                     <div className="cost_hint">Capacity baseline: 850 lbs/hr by 2 men (scaled)</div>
// // // //                   </div>
// // // //                   <div>
// // // //                     <label htmlFor="destUnloadTrailerTimeHrs">Unloading Time (from Trailer)</label>
// // // //                     <div className="cost_unit">
// // // //                       <input
// // // //                         id="destUnloadTrailerTimeHrs"
// // // //                         type="number"
// // // //                         min="0"
// // // //                         step="0.01"
// // // //                         placeholder="0"
// // // //                         value={form.destUnloadTrailerTimeHrs || ""}
// // // //                         readOnly
// // // //                       />
// // // //                       <span>hrs</span>
// // // //                     </div>
// // // //                     <div className="cost_hint">Additional unload at Destination Hub from trailer</div>
// // // //                   </div>
// // // //                   <div>
// // // //                     <label htmlFor="destDriverCost">Driver Cost</label>
// // // //                     <div className="cost_unit">
// // // //                       <input
// // // //                         id="destDriverCost"
// // // //                         type="number"
// // // //                         min="0"
// // // //                         step="0.01"
// // // //                         placeholder="0"
// // // //                         value={form.destDriverCost || ""}
// // // //                         readOnly
// // // //                       />
// // // //                       <span>$</span>
// // // //                     </div>
// // // //                     <div className="cost_hint">(Billable + Non-billable + Load + Unload + Unload from Trailer) × $20</div>
// // // //                   </div>
// // // //                   <div>
// // // //                     <label htmlFor="destHelpersCost">Helpers Cost</label>
// // // //                     <div className="cost_unit">
// // // //                       <input
// // // //                         id="destHelpersCost"
// // // //                         type="number"
// // // //                         min="0"
// // // //                         step="0.01"
// // // //                         placeholder="0"
// // // //                         value={form.destHelpersCost || ""}
// // // //                         readOnly
// // // //                       />
// // // //                       <span>$</span>
// // // //                     </div>
// // // //                     <div className="cost_hint">Per helper: ((All load/unload) × $20 + (Travel × $10)) × helpers</div>
// // // //                   </div>
// // // //                   <div>
// // // //                     <label htmlFor="destTotalLabour">Total Labour Cost</label>
// // // //                     <div className="cost_unit">
// // // //                       <input
// // // //                         id="destTotalLabour"
// // // //                         type="number"
// // // //                         min="0"
// // // //                         step="0.01"
// // // //                         placeholder="0"
// // // //                         value={form.destTotalLabour || ""}
// // // //                         readOnly
// // // //                       />
// // // //                       <span>$</span>
// // // //                     </div>
// // // //                   </div>
// // // //                   <div>
// // // //                     <label htmlFor="destTruckCost">Truck Cost</label>
// // // //                     <div className="cost_unit">
// // // //                       <input
// // // //                         id="destTruckCost"
// // // //                         type="number"
// // // //                         min="0"
// // // //                         step="0.01"
// // // //                         placeholder="0"
// // // //                         value={form.destTruckCost || ""}
// // // //                         readOnly
// // // //                       />
// // // //                       <span>$</span>
// // // //                     </div>
// // // //                     <div className="cost_hint">From Truck Cost above</div>
// // // //                   </div>
// // // //                   <div>
// // // //                     <label htmlFor="destFuelCost">Fuel Cost (Destination)</label>
// // // //                     <div className="cost_unit">
// // // //                       <input
// // // //                         id="destFuelCost"
// // // //                         type="number"
// // // //                         min="0"
// // // //                         step="0.01"
// // // //                         placeholder="0"
// // // //                         value={form.destFuelCost || ""}
// // // //                         readOnly
// // // //                       />
// // // //                       <span>$</span>
// // // //                     </div>
// // // //                     <div className="cost_hint">Formula: ((Dest→Customer + Customer→Dest) ÷ 3.5) × 1.7</div>
// // // //                   </div>
// // // //                   <div>
// // // //                     <label htmlFor="destSubtotal">Subtotal (Destination Side)</label>
// // // //                     <div className="cost_unit">
// // // //                       <input
// // // //                         id="destSubtotal"
// // // //                         type="number"
// // // //                         min="0"
// // // //                         step="0.01"
// // // //                         placeholder="0"
// // // //                         value={form.destSubtotal || ""}
// // // //                         readOnly
// // // //                       />
// // // //                       <span>$</span>
// // // //                     </div>
// // // //                   </div>
// // // //                 </div>
// // // //               </div>
// // // //             </div>
// // // //           )}
// // // //         </section>

// // // //         <section className="cost_card">
// // // //           <div className="cost_row" style={{ justifyContent: "space-between" }}>
// // // //             <h2 style={{ margin: 0, fontSize: "1.05rem" }}>Results</h2>
// // // //           </div>
// // // //           <div className="cost_bar"></div>
// // // //           {!collapsedSections.results && (
// // // //             <>
// // // //               <div className="cost_btns">
// // // //                 <button className="cost_primary" onClick={calculate}>Calculate</button>
// // // //                 <button onClick={reset}>Reset</button>
// // // //               </div>
// // // //               <div className="cost_grid cost_cols-2">
// // // //                 <div className="cost_out">
// // // //                   <div className="cost_hint">Estimated Total</div>
// // // //                   <div className="cost_tot" id="totalCostDisplay">{fmtMoney(totalCost)}</div>
// // // //                   <div className="cost_note">Live formulas based on your rules.</div>
// // // //                 </div>
// // // //                 <div className="cost_out">
// // // //                   <div className="cost_hint">Breakdown</div>
// // // //                   <pre style={{ whiteSpace: "pre-wrap", margin: 0 }}>{breakdown}</pre>
// // // //                 </div>
// // // //               </div>
// // // //             </>
// // // //           )}
// // // //         </section>
// // // //       </main>
// // // //     </div>
// // // //   );
// // // // };

// // // // export default LongMoveCostCalculator;
// // // // after recalaulate

// // import React, { useState, useEffect } from "react";
// // import './CostCalculator.css';

// // const LongMoveCostCalculator = ({ booking }) => {
// //   const MOVE_WEIGHT = {
// //     studio: 1500,
// //     "1br": 2500,
// //     "2br": 4000,
// //     "3br": 6000,
// //     "4br": 8000,
// //   };

// //   const MOVE_TRUCK = {
// //     studio: "16 ft",
// //     "1br": "16–20 ft",
// //     "2br": "20–22 ft",
// //     "3br": "26 ft",
// //     "4br": "26+ ft / 5-ton",
// //   };

// //   const hubs = [
// //     { value: "", label: "Select hub…" },
// //     { value: "43.6532,-79.3832", label: "Toronto Hub" },
// //     { value: "49.2827,-123.1207", label: "Vancouver Hub" },
// //     { value: "51.0447,-114.0719", label: "Calgary Hub" },
// //     { value: "13.0827,80.2707", label: "Chennai Hub" },
// //   ];

// //   const moveSizes = [
// //     { value: "", label: "Select size…" },
// //     { value: "studio", label: "Studio" },
// //     { value: "1br", label: "1 Bedroom" },
// //     { value: "2br", label: "2 Bedroom" },
// //     { value: "3br", label: "3 Bedroom" },
// //     { value: "4br", label: "4 Bedroom" },
// //   ];

// //   const normalizeMoveSize = (moveSize) => {
// //     const moveSizeMap = {
// //       Studio: "studio",
// //       "1 Bedroom": "1br",
// //       "2 Bedroom": "2br",
// //       "3 Bedroom": "3br",
// //       "4 Bedroom": "4br",
// //     };
// //     return moveSizeMap[moveSize] || moveSize.toLowerCase();
// //   };

// //   const parseMoveSize = (input) => {
// //     if (!input) return { moveSize: "", weight: "" };
// //     const match = input.match(/(.*?)(\d+)\s*lbs$/i);
// //     if (match) {
// //       const rawSize = match[1].trim();
// //       const weight = match[2];
// //       const normalizedSize = normalizeMoveSize(rawSize);
// //       return { moveSize: normalizedSize, weight };
// //     } else {
// //       return { moveSize: normalizeMoveSize(input), weight: "" };
// //     }
// //   };

// //   const getStaircaseFee = (stairs) => {
// //     if (stairs >= 40) return 600;
// //     if (stairs >= 30 && stairs < 40) return 450;
// //     if (stairs >= 20 && stairs < 30) return 300;
// //     if (stairs >= 10 && stairs < 20) return 150;
// //     return 0;
// //   };

// //   const getLongWalkCharges = (yards) => {
// //     if (yards >= 150) return 300;
// //     if (yards >= 100 && yards < 150) return 250;
// //     if (yards >= 50 && yards < 100) return 200;
// //     if (yards >= 40 && yards < 50) return 150;
// //     return 0;
// //   };

// //   const [form, setForm] = useState({
// //     startingHub: "",
// //     moveDate: booking?.Move_Date || "",
// //     origin: booking?.FromAddress || booking?.OriginCity || "",
// //     destination: booking?.ToAddress || booking?.DestinationCity || "",
// //     staircaseFee: "",
// //     longWalkCharges: "",
// //     stopHub: "",
// //     km1: "", // Start → Origin
// //     km2: "", // Origin → Start
// //     km3: "", // Destination → Stop
// //     km4: "", // Stop → Destination
// //     origBillTimeHrs: "",
// //     origNonBillTimeHrs: "",
// //     origLoadTimeHrs: "",
// //     origUnloadTimeHrs: "",
// //     origLoadTrailerTimeHrs: "",
// //     destBillTimeHrs: "",
// //     destNonBillTimeHrs: "",
// //     destLoadTimeHrs: "",
// //     destUnloadTimeHrs: "",
// //     destUnloadTrailerTimeHrs: "",
// //     origDriverCost: "",
// //     origHelpersCost: "",
// //     origTotalLabour: "",
// //     origTruckCost: "",
// //     origFuelCost: "",
// //     origSubtotal: "",
// //     transTrailerCost: "",
// //     transSubtotal: "",
// //     destDriverCost: "",
// //     destHelpersCost: "",
// //     destTotalLabour: "",
// //     destTruckCost: "",
// //     destFuelCost: "",
// //     destSubtotal: "",
// //     moveSize: "",
// //     estWeightLbs: "",
// //     truckSize: "",
// //     numMen: "2",
// //     truckCost: "200",
// //     subTotal: "",
// //     leadCost: "0",
// //     opsExpense: "0",
// //     profitPct: "50",
// //     ACVLSplitPct: "50",
// //     vendorsplitPct: "50",
// //   });

// //   const [distanceStatus, setDistanceStatus] = useState(
// //     "Enter all locations to fetch distances and times."
// //   );
// //   const [totalCost, setTotalCost] = useState(0);
// //   const [breakdown, setBreakdown] = useState("");
// //   const [apiKey, setApiKey] = useState("");
// //   const [isDistanceFetched, setIsDistanceFetched] = useState(false);
// //   const [isFetching, setIsFetching] = useState(false);
// //   const [collapsedSections, setCollapsedSections] = useState({
// //     jobDetails: true,
// //     moveDetails: true,
// //     distanceCost: true,
// //     results: false,
// //   });

// //   useEffect(() => {
// //     const fetchApiKey = async () => {
// //       try {
// //         const response = await fetch("https://salesjet-10097049716.catalystappsail.com/api/get-google-api-key");
// //         const data = await response.json();
// //         setApiKey(data.apiKey);
// //       } catch (error) {
// //         console.error("Failed to fetch API key:", error);
// //         setDistanceStatus("Error fetching API key.");
// //       }
// //     };

// //     fetchApiKey();

// //     const { moveSize: normalizedMoveSize, weight } = parseMoveSize(booking?.Move_Size);
// //     const totalStairs = parseInt(booking?.NoOfStaircasesAtOrigin || 0) + parseInt(booking?.NoOfStaircasesAtDestination || 0);
// //     const staircaseFee = getStaircaseFee(totalStairs);
// //     const totalYards = parseFloat(booking?.LongWalkAtOrigin || 0) + parseFloat(booking?.LongWalkAtDestination || 0);
// //     const longWalkCharges = getLongWalkCharges(totalYards);
// //     const updates = {
// //       origin: booking?.FromAddress || booking?.OriginCity || "",
// //       destination: booking?.ToAddress || booking?.DestinationCity || "",
// //       moveSize: normalizedMoveSize,
// //       estWeightLbs: weight || (normalizedMoveSize ? MOVE_WEIGHT[normalizedMoveSize] || "" : ""),
// //       truckSize: normalizedMoveSize ? MOVE_TRUCK[normalizedMoveSize] || "" : "",
// //       staircaseFee: staircaseFee.toFixed(2),
// //       longWalkCharges: longWalkCharges.toFixed(2),
// //       origTruckCost: "200",
// //       destTruckCost: "200",
// //     };
// //     setForm((prev) => ({ ...prev, ...updates }));
// //     if (normalizedMoveSize || weight) {
// //       autoCalculateTimesAndCosts();
// //     }
// //   }, [booking]);

// //   useEffect(() => {
// //     if (
// //       form.km1 ||
// //       form.km2 ||
// //       form.km3 ||
// //       form.km4 ||
// //       form.origBillTimeHrs ||
// //       form.origNonBillTimeHrs ||
// //       form.destBillTimeHrs ||
// //       form.destNonBillTimeHrs ||
// //       form.estWeightLbs ||
// //       form.numMen ||
// //       form.truckCost ||
// //       form.profitPct ||
// //       form.ACVLSplitPct ||
// //       form.staircaseFee ||
// //       form.longWalkCharges
// //     ) {
// //       calculate();
// //     }
// //   }, [
// //     form.km1,
// //     form.km2,
// //     form.km3,
// //     form.km4,
// //     form.origBillTimeHrs,
// //     form.origNonBillTimeHrs,
// //     form.destBillTimeHrs,
// //     form.destNonBillTimeHrs,
// //     form.estWeightLbs,
// //     form.numMen,
// //     form.truckCost,
// //     form.profitPct,
// //     form.ACVLSplitPct,
// //     form.staircaseFee,
// //     form.longWalkCharges,
// //   ]);

// //   const fmtMoney = (v) =>
// //     isFinite(v) ? (v < 0 ? "-$" : "$") + Math.abs(v).toFixed(2) : "$0.00";

// //   const updateForm = (updates) => {
// //     setForm((prev) => {
// //       const newForm = { ...prev, ...updates };
// //       if (updates.ACVLSplitPct !== undefined) {
// //         newForm.vendorsplitPct = (100 - parseFloat(updates.ACVLSplitPct || 0)).toString();
// //       }
// //       return newForm;
// //     });
// //   };

// //   const autoCalculateTimesAndCosts = () => {
// //     const w = parseFloat(form.estWeightLbs) || 0;
// //     console.log("Auto-calculating with weight:", w);
// //     const men = Math.max(1, parseInt(form.numMen || 0));
// //     const crewFactor = men / 2;
// //     const km1 = parseFloat(form.km1) || 0;
// //     const km2 = parseFloat(form.km2) || 0;
// //     const km3 = parseFloat(form.km3) || 0;
// //     const km4 = parseFloat(form.km4) || 0;
// //     const truckCost = parseFloat(form.truckCost) || 200;
// //     const origBillTime = parseFloat(form.origBillTimeHrs) || 0;
// //     const origNonBillTime = parseFloat(form.origNonBillTimeHrs) || 0;
// //     const destBillTime = parseFloat(form.destBillTimeHrs) || 0;
// //     const destNonBillTime = parseFloat(form.destNonBillTimeHrs) || 0;

// //     // Origin Side Calculations
// //     const origLoadTime = crewFactor > 0 ? w / (650 * crewFactor) : 0;
// //     const origUnloadTime = crewFactor > 0 ? w / (850 * crewFactor) : 0;
// //     const origLoadTrailerTime = crewFactor > 0 ? w / (650 * crewFactor) : 0;
// //     const origDriverCost = (origBillTime + origNonBillTime + origLoadTime + origUnloadTime + origLoadTrailerTime) * 20;
// //     const origHelpers = Math.max(0, men - 1);
// //     const origHelperPer = (origLoadTime + origUnloadTime + origLoadTrailerTime) * 20 + (origBillTime + origNonBillTime) * 10;
// //     const origHelpersCost = origHelpers * origHelperPer;
// //     const origTotalLabour = origDriverCost + origHelpersCost;
// //     const origFuelCost = ((km1 + km2) / 3.5) * 1.7;
// //     const origSubtotal = origTotalLabour + truckCost + origFuelCost;

// //     // Transit Calculations
// //     const transTrailerCost = w * .55;
// //     const transSubtotal = transTrailerCost;

// //     // Destination Side Calculations
// //     const destLoadTime = crewFactor > 0 ? w / (650 * crewFactor) : 0;
// //     const destUnloadTime = crewFactor > 0 ? w / (850 * crewFactor) : 0;
// //     const destUnloadTrailerTime = crewFactor > 0 ? w / (850 * crewFactor) : 0;
// //     const destDriverCost = (destBillTime + destNonBillTime + destLoadTime + destUnloadTime + destUnloadTrailerTime) * 20;
// //     const destHelpers = Math.max(0, men - 1);
// //     const destHelperPer = (destLoadTime + destUnloadTime + destUnloadTrailerTime) * 20 + (destBillTime + destNonBillTime) * 10;
// //     const destHelpersCost = destHelpers * destHelperPer;
// //     const destTotalLabour = destDriverCost + destHelpersCost;
// //     const destFuelCost = ((km3 + km4) / 3.5) * 1.7;
// //     const destSubtotal = destTotalLabour + truckCost + destFuelCost;

// //     // Fixed Costs
// //     const subTotal = origSubtotal + transSubtotal + destSubtotal + parseFloat(form.staircaseFee || 0) + parseFloat(form.longWalkCharges || 0);
// //     const leadCost = subTotal * 0.05;
// //     const opsExpense = subTotal * 0.10;

// //     updateForm({
// //       origLoadTimeHrs: origLoadTime.toFixed(2),
// //       origUnloadTimeHrs: origUnloadTime.toFixed(2),
// //       origLoadTrailerTimeHrs: origLoadTrailerTime.toFixed(2),
// //       origDriverCost: origDriverCost.toFixed(2),
// //       origHelpersCost: origHelpersCost.toFixed(2),
// //       origTotalLabour: origTotalLabour.toFixed(2),
// //       origTruckCost: truckCost.toFixed(2),
// //       origFuelCost: origFuelCost.toFixed(2),
// //       origSubtotal: origSubtotal.toFixed(2),
// //       transTrailerCost: transTrailerCost.toFixed(2),
// //       transSubtotal: transSubtotal.toFixed(2),
// //       destLoadTimeHrs: destLoadTime.toFixed(2),
// //       destUnloadTimeHrs: destUnloadTime.toFixed(2),
// //       destUnloadTrailerTimeHrs: destUnloadTrailerTime.toFixed(2),
// //       destDriverCost: destDriverCost.toFixed(2),
// //       destHelpersCost: destHelpersCost.toFixed(2),
// //       destTotalLabour: destTotalLabour.toFixed(2),
// //       destTruckCost: truckCost.toFixed(2),
// //       destFuelCost: destFuelCost.toFixed(2),
// //       destSubtotal: destSubtotal.toFixed(2),
// //       subTotal: subTotal.toFixed(2),
// //       leadCost: leadCost.toFixed(2),
// //       opsExpense: opsExpense.toFixed(2),
// //     });
// //   };

// //   const fetchDistances = async () => {
// //     setDistanceStatus('Looking up distances and times…');
// //     setIsFetching(true);
// //     setIsDistanceFetched(false);
// //     try {
// //       const { startingHub, stopHub, origin, destination } = form;
// //       if (!(startingHub && stopHub && origin && destination)) {
// //         setDistanceStatus('Please fill Starting Hub, Stop Hub, Origin, and Destination.');
// //         setIsFetching(false);
// //         return;
// //       }

// //       const response = await fetch('https://salesjet-10097049716.catalystappsail.com/api/long-calculate-distances', {
// //         method: 'POST',
// //         headers: { 'Content-Type': 'application/json' },
// //         body: JSON.stringify({ startingHub, stopHub, origin, destination }),
// //       });

// //       if (!response.ok) {
// //         throw new Error('Failed to fetch distances from server.');
// //       }

// //       const {
// //         km1,
// //         km2,
// //         km3,
// //         km4,
// //         billableKm,
// //         origBillTimeHrs,
// //         origNonBillTimeHrs,
// //         destBillTimeHrs,
// //         destNonBillTimeHrs,
// //         billableTimeHrs,
// //       } = await response.json();

// //       console.log('Fetched data:', {
// //         km1,
// //         km2,
// //         km3,
// //         km4,
// //         billableKm,
// //         origBillTimeHrs,
// //         origNonBillTimeHrs,
// //         destBillTimeHrs,
// //         destNonBillTimeHrs,
// //         billableTimeHrs,
// //       });

// //       updateForm({
// //         km1,
// //         km2,
// //         km3,
// //         km4,
// //         origBillTimeHrs,
// //         origNonBillTimeHrs,
// //         destBillTimeHrs,
// //         destNonBillTimeHrs,
// //       });

// //       autoCalculateTimesAndCosts();
// //       setIsDistanceFetched(true);
// //       setDistanceStatus(
// //         `Updated ✓ Legs: ${km1} km (${origBillTimeHrs} hrs), ${km2} km (${origNonBillTimeHrs} hrs), ${km3} km (${destBillTimeHrs} hrs), ${km4} km (${destNonBillTimeHrs} hrs) | Billable: ${billableKm} km (${billableTimeHrs} hrs)`
// //       );
// //     } catch (err) {
// //       console.error(err);
// //       setDistanceStatus('Distance and time lookup failed. Check locations or try again.');
// //       setIsDistanceFetched(false);
// //     } finally {
// //       setIsFetching(false);
// //     }
// //   };

// //   const calculate = () => {
// //     autoCalculateTimesAndCosts();

// //     const subTotal = parseFloat(form.subTotal) || 0;
// //     const lead = parseFloat(form.leadCost) || 0;
// //     const ops = parseFloat(form.opsExpense) || 0;
// //     const profitPct = (parseFloat(form.profitPct) || 0) / 100;
// //     const acvlSplitPct = (parseFloat(form.ACVLSplitPct) || 0) / 100;
// //     const vendorSplitPct = (parseFloat(form.vendorsplitPct) || 0) / 100;
// //     const profitBase = subTotal + lead + ops;
// //     const profit = profitBase * profitPct;
// //     const total = profitBase + profit;
// //     const acvlProfit = profit * acvlSplitPct;
// //     const vendorProfit = profit * vendorSplitPct;

// //     setTotalCost(total);
// //     setBreakdown(
// //       `Origin Side:
// //   Billable Travel Time: ${form.origBillTimeHrs || 0} hrs
// //   Non-Billable Travel Time: ${form.origNonBillTimeHrs || 0} hrs
// //   Loading: ${form.origLoadTimeHrs || 0} hrs
// //   Unloading: ${form.origUnloadTimeHrs || 0} hrs
// //   Loading into Trailer: ${form.origLoadTrailerTimeHrs || 0} hrs
// //   Driver: ${fmtMoney(parseFloat(form.origDriverCost) || 0)}
// //   Helpers: ${fmtMoney(parseFloat(form.origHelpersCost) || 0)}
// //   Truck: ${fmtMoney(parseFloat(form.origTruckCost) || 0)}
// //   Fuel: ${fmtMoney(parseFloat(form.origFuelCost) || 0)}
// //   Subtotal (Origin): ${fmtMoney(parseFloat(form.origSubtotal) || 0)}
// // Transit:
// //   Trailer Transit: ${fmtMoney(parseFloat(form.transTrailerCost) || 0)}
// //   Subtotal (Transit): ${fmtMoney(parseFloat(form.transSubtotal) || 0)}
// // Destination Side:
// //   Billable Travel Time: ${form.destBillTimeHrs || 0} hrs
// //   Non-Billable Travel Time: ${form.destNonBillTimeHrs || 0} hrs
// //   Loading: ${form.destLoadTimeHrs || 0} hrs
// //   Unloading: ${form.destUnloadTimeHrs || 0} hrs
// //   Unloading from Trailer: ${form.destUnloadTrailerTimeHrs || 0} hrs
// //   Driver: ${fmtMoney(parseFloat(form.destDriverCost) || 0)}
// //   Helpers: ${fmtMoney(parseFloat(form.destHelpersCost) || 0)}
// //   Truck: ${fmtMoney(parseFloat(form.destTruckCost) || 0)}
// //   Fuel: ${fmtMoney(parseFloat(form.destFuelCost) || 0)}
// //   Subtotal (Dest): ${fmtMoney(parseFloat(form.destSubtotal) || 0)}
// // Totals:
// //   Local Labour (Origin+Dest): ${fmtMoney((parseFloat(form.origTotalLabour) || 0) + (parseFloat(form.destTotalLabour) || 0))}
// //   Total Fuel: ${fmtMoney((parseFloat(form.origFuelCost) || 0) + (parseFloat(form.destFuelCost) || 0))}
// //   Trailer Transit: ${fmtMoney(parseFloat(form.transTrailerCost) || 0)}
// //   Stairs: ${fmtMoney(parseFloat(form.staircaseFee) || 0)}
// //   Long Walk: ${fmtMoney(parseFloat(form.longWalkCharges) || 0)}
// //   SubTotal: ${fmtMoney(subTotal)}
// //   Lead (5%): ${fmtMoney(lead)}
// //   Ops (10%): ${fmtMoney(ops)}
// //   Profit (${form.profitPct || 0}%): ${fmtMoney(profit)}
// //     ACVL (${form.ACVLSplitPct || 0}%): ${fmtMoney(acvlProfit)}
// //     Vendor (${form.vendorsplitPct || 0}%): ${fmtMoney(vendorProfit)}
// // Grand Total: ${fmtMoney(total)}`
// //     );
// //   };

// //   const reset = () => {
// //     setForm({
// //       startingHub: "",
// //       moveDate: booking?.Move_Date || "",
// //       origin: booking?.FromAddress || booking?.OriginCity || "",
// //       destination: booking?.ToAddress || booking?.DestinationCity || "",
// //       stopHub: "",
// //       km1: "",
// //       km2: "",
// //       km3: "",
// //       km4: "",
// //       origBillTimeHrs: "",
// //       origNonBillTimeHrs: "",
// //       origLoadTimeHrs: "",
// //       origUnloadTimeHrs: "",
// //       origLoadTrailerTimeHrs: "",
// //       destBillTimeHrs: "",
// //       destNonBillTimeHrs: "",
// //       destLoadTimeHrs: "",
// //       destUnloadTimeHrs: "",
// //       destUnloadTrailerTimeHrs: "",
// //       origDriverCost: "",
// //       origHelpersCost: "",
// //       origTotalLabour: "",
// //       origTruckCost: "200",
// //       origFuelCost: "",
// //       origSubtotal: "",
// //       transTrailerCost: "",
// //       transSubtotal: "",
// //       destDriverCost: "",
// //       destHelpersCost: "",
// //       destTotalLabour: "",
// //       destTruckCost: "200",
// //       destFuelCost: "",
// //       destSubtotal: "",
// //       moveSize: "",
// //       estWeightLbs: "",
// //       truckSize: "",
// //       numMen: "2",
// //       truckCost: "200",
// //       subTotal: "",
// //       leadCost: "0",
// //       opsExpense: "0",
// //       profitPct: "50",
// //       ACVLSplitPct: "50",
// //       vendorsplitPct: "50",
// //       staircaseFee: "",
// //       longWalkCharges: "",
// //     });
// //     setDistanceStatus("Enter all locations to fetch distances and times.");
// //     setTotalCost(0);
// //     setBreakdown("");
// //     setIsDistanceFetched(false);
// //     setIsFetching(false);
// //     setCollapsedSections({
// //       jobDetails: false,
// //       moveDetails: false,
// //       distanceCost: false,
// //       results: false,
// //     });
// //   };

// //   const toggleSection = (section) => {
// //     setCollapsedSections((prev) => ({
// //       ...prev,
// //       [section]: !prev[section],
// //     }));
// //   };

// //   const SelectField = ({ id, label, options, hint, onChange }) => (
// //     <div>
// //       <label htmlFor={id}>{label}</label>
// //       <select
// //         id={id}
// //         value={form[id] || ""}
// //         onChange={onChange || ((e) => updateForm({ [id]: e.target.value }))}
// //       >
// //         {options.map((opt) => (
// //           <option key={opt.value} value={opt.value}>{opt.label}</option>
// //         ))}
// //       </select>
// //       {hint && <div className="cost_hint">{hint}</div>}
// //     </div>
// //   );

// //   const ComboField = ({ id, label, options, hint }) => (
// //     <div>
// //       <label htmlFor={id}>{label}</label>
// //       <input
// //         id={id}
// //         type="text"
// //         list={`${id}-datalist`}
// //         value={form[id] || ""}
// //         onChange={(e) => updateForm({ [id]: e.target.value })}
// //         placeholder="Type location or select hub..."
// //       />
// //       <datalist id={`${id}-datalist`}>
// //         {options.map((opt) => (
// //           <option key={opt.value} value={opt.value}>
// //             {opt.label}
// //           </option>
// //         ))}
// //       </datalist>
// //       {hint && <div className="cost_hint">{hint}</div>}
// //     </div>
// //   );

// //   return (
// //     <div className="cost_wrap">
// //       <main className="cost_wrap">
// //         <section className="cost_card">
// //           <div className="cost_row" style={{ justifyContent: "space-between" }}>
// //             <h2 style={{ margin: 0, fontSize: "1.05rem" }}>Job Details</h2>
// //             <div style={{ display: "flex", alignItems: "center" }}>
// //               <span className="cost_pill">All distances in KM • Times from Google Maps</span>
// //               <button
// //                 onClick={() => toggleSection("jobDetails")}
// //                 style={{
// //                   marginLeft: "10px",
// //                   fontSize: "1.2rem",
// //                   cursor: "pointer",
// //                   color: "#333",
// //                   border: "none",
// //                   background: "none",
// //                 }}
// //               >
// //                 {collapsedSections.jobDetails ? "+" : "−"}
// //               </button>
// //             </div>
// //           </div>
// //           <div className="cost_bar"></div>
// //           {!collapsedSections.jobDetails && (
// //             <div className="cost_grid cost_cols-3">
// //               <div>
// //                 <label htmlFor="origin">Origin (City, Province)</label>
// //                 <div className="cost_unit">
// //                   <input
// //                     id="origin"
// //                     type="text"
// //                     placeholder="City, ST, Country or lat,lon"
// //                     value={form.origin || ""}
// //                     onChange={(e) => updateForm({ origin: e.target.value })}
// //                   />
// //                 </div>
// //               </div>
// //               <div>
// //                 <label htmlFor="destination">Destination (City, Province)</label>
// //                 <div className="cost_unit">
// //                   <input
// //                     id="destination"
// //                     type="text"
// //                     placeholder="City, ST, Country or lat,lon"
// //                     value={form.destination || ""}
// //                     onChange={(e) => updateForm({ destination: e.target.value })}
// //                   />
// //                 </div>
// //               </div>
// //               <div>
// //                 <label htmlFor="moveDate">Move Date</label>
// //                 <div className="cost_unit">
// //                   <input
// //                     id="moveDate"
// //                     type="text"
// //                     placeholder="YYYY-MM-DD"
// //                     value={form.moveDate || ""}
// //                     onChange={(e) => updateForm({ moveDate: e.target.value })}
// //                   />
// //                 </div>
// //               </div>
// //               <div>
// //                 <label htmlFor="moveSize">Move Size (Bedrooms)</label>
// //                 <div className="cost_unit">
// //                   <input
// //                     id="moveSize"
// //                     type="text"
// //                     placeholder="Select size…"
// //                     value={moveSizes.find(opt => opt.value === form.moveSize)?.label || form.moveSize || ""}
// //                     readOnly
// //                   />
// //                 </div>
// //               </div>
// //             </div>
// //           )}
// //         </section>

// //         <section className="cost_card">
// //           <div className="cost_row" style={{ justifyContent: "space-between" }}>
// //             <h2 style={{ margin: 0, fontSize: "1.05rem" }}>Move Details & Profit Range</h2>
// //             <button
// //               onClick={() => toggleSection("moveDetails")}
// //               style={{
// //                 fontSize: "1.2rem",
// //                 cursor: "pointer",
// //                 color: "#333",
// //                 border: "none",
// //                 background: "none",
// //               }}
// //             >
// //               {collapsedSections.moveDetails ? "+" : "−"}
// //             </button>
// //           </div>
// //           <div className="cost_bar"></div>
// //           {!collapsedSections.moveDetails && (
// //             <>
// //               <div className="cost_grid cost_cols-3">
// //                 <ComboField
// //                   id="startingHub"
// //                   label="Starting Location (Hub)"
// //                   options={hubs}
// //                 />
// //                 <ComboField
// //                   id="stopHub"
// //                   label="Stop Location (Hub)"
// //                   options={hubs}
// //                 />
// //               </div>
// //               <div className="cost_btns" style={{ marginTop: "8px", position: "relative" }}>
// //                 <button
// //                   type="button"
// //                   onClick={fetchDistances}
// //                   className={isDistanceFetched ? "cost_fetched" : isFetching ? "cost_fetching" : ""}
// //                 >
// //                   Fetch distances and times (Google Maps)
// //                   {isFetching && (
// //                     <span className="spinner" style={{ marginLeft: "8px" }}>↻</span>
// //                   )}
// //                 </button>
// //               </div>
// //               <div className="cost_grid cost_cols-3" style={{ marginTop: "10px" }}>
// //                 <div>
// //                   <label htmlFor="estWeightLbs">Estimated Weight</label>
// //                   <div className="cost_unit">
// //                     <input
// //                       id="estWeightLbs"
// //                       type="number"
// //                       min="0"
// //                       step="1"
// //                       placeholder="0"
// //                       value={form.estWeightLbs || ""}
// //                       onChange={(e) => {
// //                         updateForm({ estWeightLbs: e.target.value });
// //                         autoCalculateTimesAndCosts();
// //                       }}
// //                     />
// //                     <span>lbs</span>
// //                   </div>
// //                 </div>
// //                 <div>
// //                   <label htmlFor="truckSize">Truck Size</label>
// //                   <div className="cost_unit">
// //                     <input
// //                       id="truckSize"
// //                       type="text"
// //                       placeholder="e.g., 16 ft / 20 ft / 26 ft"
// //                       value={form.truckSize || ""}
// //                       onChange={(e) => updateForm({ truckSize: e.target.value })}
// //                     />
// //                   </div>
// //                 </div>
// //                 <div>
// //                   <label htmlFor="numMen">Number of Men</label>
// //                   <div className="cost_unit">
// //                     <input
// //                       id="numMen"
// //                       type="number"
// //                       min="1"
// //                       step="1"
// //                       placeholder="2"
// //                       value={form.numMen || ""}
// //                       onChange={(e) => {
// //                         updateForm({ numMen: e.target.value });
// //                         autoCalculateTimesAndCosts();
// //                       }}
// //                     />
// //                   </div>
// //                 </div>
// //                 <div>
// //                   <label htmlFor="truckCost">Truck Cost</label>
// //                   <div className="cost_unit">
// //                     <input
// //                       id="truckCost"
// //                       type="number"
// //                       min="0"
// //                       step="0.01"
// //                       placeholder="200"
// //                       value={form.truckCost || ""}
// //                       onChange={(e) => {
// //                         updateForm({ truckCost: e.target.value, origTruckCost: e.target.value, destTruckCost: e.target.value });
// //                         autoCalculateTimesAndCosts();
// //                       }}
// //                     />
// //                     <span>$</span>
// //                   </div>
// //                   <div className="cost_hint">Enter truck rental or usage cost manually.</div>
// //                 </div>
// //                 <div>
// //                   <label htmlFor="profitPct">Profit Percentage</label>
// //                   <div className="cost_unit">
// //                     <input
// //                       id="profitPct"
// //                       type="number"
// //                       min="0"
// //                       step="0.1"
// //                       placeholder="50"
// //                       value={form.profitPct || ""}
// //                       onChange={(e) => {
// //                         updateForm({ profitPct: e.target.value });
// //                       }}
// //                     />
// //                     <span>%</span>
// //                   </div>
// //                   <div className="cost_hint">Applied to (Sub-Total + Lead + Ops)</div>
// //                 </div>
// //                 <div>
// //                   <label htmlFor="ACVLSplitPct">ACVL Profit Split</label>
// //                   <div className="cost_unit">
// //                     <input
// //                       id="ACVLSplitPct"
// //                       type="number"
// //                       min="0"
// //                       max="100"
// //                       step="0.1"
// //                       placeholder="50"
// //                       value={form.ACVLSplitPct || ""}
// //                       onChange={(e) => {
// //                         updateForm({ ACVLSplitPct: e.target.value });
// //                       }}
// //                     />
// //                     <span>%</span>
// //                   </div>
// //                 </div>
// //                 <div>
// //                   <label htmlFor="vendorsplitPct">Vendor Profit Split</label>
// //                   <div className="cost_unit">
// //                     <input
// //                       id="vendorsplitPct"
// //                       type="number"
// //                       min="0"
// //                       max="100"
// //                       step="0.1"
// //                       placeholder="50"
// //                       value={form.vendorsplitPct || ""}
// //                       readOnly
// //                     />
// //                     <span>%</span>
// //                   </div>
// //                 </div>
// //               </div>
// //             </>
// //           )}
// //         </section>

// //         <section className="cost_card">
// //           <div className="cost_row" style={{ justifyContent: "space-between" }}>
// //             <h2 style={{ margin: 0, fontSize: "1.05rem" }}>Detailed Cost Breakdown</h2>
// //             <button
// //               onClick={() => toggleSection("distanceCost")}
// //               style={{
// //                 fontSize: "1.2rem",
// //                 cursor: "pointer",
// //                 border: "none",
// //                 color: "#333",
// //                 background: "none",
// //               }}
// //             >
// //               {collapsedSections.distanceCost ? "+" : "−"}
// //             </button>
// //           </div>
// //           <div className="cost_bar"></div>
// //           {!collapsedSections.distanceCost && (
// //             <div>
// //               {/* Origin Side */}
// //               <div style={{ marginBottom: "12px" }}>
// //                 <h5 style={{ margin: "0.2rem 0" }}>Origin Side Cost</h5>
// //                 <div className="cost_bar"></div>
// //                 <div className="cost_grid cost_cols-3">
// //                   <div>
// //                     <label htmlFor="km1">Start → Origin (km)</label>
// //                     <div className="cost_unit">
// //                       <input
// //                         id="km1"
// //                         type="number"
// //                         min="0"
// //                         step="0.1"
// //                         placeholder="0"
// //                         value={form.km1 || ""}
// //                         onChange={(e) => {
// //                           updateForm({ km1: e.target.value });
// //                           autoCalculateTimesAndCosts();
// //                         }}
// //                       />
// //                       <span>km</span>
// //                     </div>
// //                   </div>
// //                   <div>
// //                     <label htmlFor="km2">Origin → Start (km)</label>
// //                     <div className="cost_unit">
// //                       <input
// //                         id="km2"
// //                         type="number"
// //                         min="0"
// //                         step="0.1"
// //                         placeholder="0"
// //                         value={form.km2 || ""}
// //                         onChange={(e) => {
// //                           updateForm({ km2: e.target.value });
// //                           autoCalculateTimesAndCosts();
// //                         }}
// //                       />
// //                       <span>km</span>
// //                     </div>
// //                   </div>
// //                   <div>
// //                     <label htmlFor="origBillTimeHrs">Billable Travel Time</label>
// //                     <div className="cost_unit">
// //                       <input
// //                         id="origBillTimeHrs"
// //                         type="number"
// //                         min="0"
// //                         step="0.01"
// //                         placeholder="0"
// //                         value={form.origBillTimeHrs || ""}
// //                         readOnly
// //                       />
// //                       <span>hrs</span>
// //                     </div>
// //                     <div className="cost_hint">Fetched from Google Maps</div>
// //                   </div>
// //                   <div>
// //                     <label htmlFor="origNonBillTimeHrs">Non-Billable Travel Time</label>
// //                     <div className="cost_unit">
// //                       <input
// //                         id="origNonBillTimeHrs"
// //                         type="number"
// //                         min="0"
// //                         step="0.01"
// //                         placeholder="0"
// //                         value={form.origNonBillTimeHrs || ""}
// //                         readOnly
// //                       />
// //                       <span>hrs</span>
// //                     </div>
// //                     <div className="cost_hint">Fetched from Google Maps</div>
// //                   </div>
// //                   <div>
// //                     <label htmlFor="origLoadTimeHrs">Loading Time</label>
// //                     <div className="cost_unit">
// //                       <input
// //                         id="origLoadTimeHrs"
// //                         type="number"
// //                         min="0"
// //                         step="0.01"
// //                         placeholder="0"
// //                         value={form.origLoadTimeHrs || ""}
// //                         readOnly
// //                       />
// //                       <span>hrs</span>
// //                     </div>
// //                     <div className="cost_hint">Capacity baseline: 650 lbs/hr by 2 men (scaled)</div>
// //                   </div>
// //                   <div>
// //                     <label htmlFor="origUnloadTimeHrs">Unloading Time</label>
// //                     <div className="cost_unit">
// //                       <input
// //                         id="origUnloadTimeHrs"
// //                         type="number"
// //                         min="0"
// //                         step="0.01"
// //                         placeholder="0"
// //                         value={form.origUnloadTimeHrs || ""}
// //                         readOnly
// //                       />
// //                       <span>hrs</span>
// //                     </div>
// //                     <div className="cost_hint">Capacity baseline: 850 lbs/hr by 2 men (scaled)</div>
// //                   </div>
// //                   <div>
// //                     <label htmlFor="origLoadTrailerTimeHrs">Loading Time (into Trailer)</label>
// //                     <div className="cost_unit">
// //                       <input
// //                         id="origLoadTrailerTimeHrs"
// //                         type="number"
// //                         min="0"
// //                         step="0.01"
// //                         placeholder="0"
// //                         value={form.origLoadTrailerTimeHrs || ""}
// //                         readOnly
// //                       />
// //                       <span>hrs</span>
// //                     </div>
// //                     <div className="cost_hint">Additional load at Origin Hub into trailer</div>
// //                   </div>
// //                   <div>
// //                     <label htmlFor="origDriverCost">Driver Cost</label>
// //                     <div className="cost_unit">
// //                       <input
// //                         id="origDriverCost"
// //                         type="number"
// //                         min="0"
// //                         step="0.01"
// //                         placeholder="0"
// //                         value={form.origDriverCost || ""}
// //                         readOnly
// //                       />
// //                       <span>$</span>
// //                     </div>
// //                     <div className="cost_hint">(Billable + Non-billable + Load + Unload + Load into Trailer) × $20</div>
// //                   </div>
// //                   <div>
// //                     <label htmlFor="origHelpersCost">Helpers Cost</label>
// //                     <div className="cost_unit">
// //                       <input
// //                         id="origHelpersCost"
// //                         type="number"
// //                         min="0"
// //                         step="0.01"
// //                         placeholder="0"
// //                         value={form.origHelpersCost || ""}
// //                         readOnly
// //                       />
// //                       <span>$</span>
// //                     </div>
// //                     <div className="cost_hint">Per helper: ((All load/unload) × $20 + (Travel × $10)) × helpers</div>
// //                   </div>
// //                   <div>
// //                     <label htmlFor="origTotalLabour">Total Labour Cost</label>
// //                     <div className="cost_unit">
// //                       <input
// //                         id="origTotalLabour"
// //                         type="number"
// //                         min="0"
// //                         step="0.01"
// //                         placeholder="0"
// //                         value={form.origTotalLabour || ""}
// //                         readOnly
// //                       />
// //                       <span>$</span>
// //                     </div>
// //                   </div>
// //                   <div>
// //                     <label htmlFor="origTruckCost">Truck Cost</label>
// //                     <div className="cost_unit">
// //                       <input
// //                         id="origTruckCost"
// //                         type="number"
// //                         min="0"
// //                         step="0.01"
// //                         placeholder="0"
// //                         value={form.origTruckCost || ""}
// //                         readOnly
// //                       />
// //                       <span>$</span>
// //                     </div>
// //                     <div className="cost_hint">From Truck Cost above</div>
// //                   </div>
// //                   <div>
// //                     <label htmlFor="origFuelCost">Fuel Cost (Origin)</label>
// //                     <div className="cost_unit">
// //                       <input
// //                         id="origFuelCost"
// //                         type="number"
// //                         min="0"
// //                         step="0.01"
// //                         placeholder="0"
// //                         value={form.origFuelCost || ""}
// //                         readOnly
// //                       />
// //                       <span>$</span>
// //                     </div>
// //                     <div className="cost_hint">Formula: ((Start→Origin + Origin→Start) ÷ 3.5) × 1.7</div>
// //                   </div>
// //                   <div>
// //                     <label htmlFor="origSubtotal">Subtotal (Origin Side)</label>
// //                     <div className="cost_unit">
// //                       <input
// //                         id="origSubtotal"
// //                         type="number"
// //                         min="0"
// //                         step="0.01"
// //                         placeholder="0"
// //                         value={form.origSubtotal || ""}
// //                         readOnly
// //                       />
// //                       <span>$</span>
// //                     </div>
// //                   </div>
// //                 </div>
// //               </div>

// //               {/* Transit */}
// //               <div style={{ marginBottom: "12px" }}>
// //                 <h5 style={{ margin: "0.2rem 0" }}>Transit</h5>
// //                 <div className="cost_bar"></div>
// //                 <div className="cost_grid cost_cols-3">
// //                   <div>
// //                     <label htmlFor="transTrailerCost">Trailer Transit Cost</label>
// //                     <div className="cost_unit">
// //                       <input
// //                         id="transTrailerCost"
// //                         type="number"
// //                         min="0"
// //                         step="0.01"
// //                         placeholder="0"
// //                         value={form.transTrailerCost || ""}
// //                         readOnly
// //                       />
// //                       <span>$</span>
// //                     </div>
// //                     <div className="cost_hint">Formula: Weight (lbs) × 0.55</div>
// //                   </div>
// //                   <div>
// //                     <label htmlFor="transSubtotal">Transit Subtotal</label>
// //                     <div className="cost_unit">
// //                       <input
// //                         id="transSubtotal"
// //                         type="number"
// //                         min="0"
// //                         step="0.01"
// //                         placeholder="0"
// //                         value={form.transSubtotal || ""}
// //                         readOnly
// //                       />
// //                       <span>$</span>
// //                     </div>
// //                   </div>
// //                 </div>
// //               </div>

// //               {/* Destination Side */}
// //               <div>
// //                 <h5 style={{ margin: "0.2rem 0" }}>Destination Side Cost</h5>
// //                 <div className="cost_bar"></div>
// //                 <div className="cost_grid cost_cols-3">
// //                   <div>
// //                     <label htmlFor="km3">Destination → Stop (km)</label>
// //                     <div className="cost_unit">
// //                       <input
// //                         id="km3"
// //                         type="number"
// //                         min="0"
// //                         step="0.1"
// //                         placeholder="0"
// //                         value={form.km3 || ""}
// //                         onChange={(e) => {
// //                           updateForm({ km3: e.target.value });
// //                           autoCalculateTimesAndCosts();
// //                         }}
// //                       />
// //                       <span>km</span>
// //                     </div>
// //                   </div>
// //                   <div>
// //                     <label htmlFor="km4">Stop → Destination (km)</label>
// //                     <div className="cost_unit">
// //                       <input
// //                         id="km4"
// //                         type="number"
// //                         min="0"
// //                         step="0.1"
// //                         placeholder="0"
// //                         value={form.km4 || ""}
// //                         onChange={(e) => {
// //                           updateForm({ km4: e.target.value });
// //                           autoCalculateTimesAndCosts();
// //                         }}
// //                       />
// //                       <span>km</span>
// //                     </div>
// //                   </div>
// //                   <div>
// //                     <label htmlFor="destBillTimeHrs">Billable Travel Time</label>
// //                     <div className="cost_unit">
// //                       <input
// //                         id="destBillTimeHrs"
// //                         type="number"
// //                         min="0"
// //                         step="0.01"
// //                         placeholder="0"
// //                         value={form.destBillTimeHrs || ""}
// //                         readOnly
// //                       />
// //                       <span>hrs</span>
// //                     </div>
// //                     <div className="cost_hint">Fetched from Google Maps</div>
// //                   </div>
// //                   <div>
// //                     <label htmlFor="destNonBillTimeHrs">Non-Billable Travel Time</label>
// //                     <div className="cost_unit">
// //                       <input
// //                         id="destNonBillTimeHrs"
// //                         type="number"
// //                         min="0"
// //                         step="0.01"
// //                         placeholder="0"
// //                         value={form.destNonBillTimeHrs || ""}
// //                         readOnly
// //                       />
// //                       <span>hrs</span>
// //                     </div>
// //                     <div className="cost_hint">Fetched from Google Maps</div>
// //                   </div>
// //                   <div>
// //                     <label htmlFor="destLoadTimeHrs">Loading Time</label>
// //                     <div className="cost_unit">
// //                       <input
// //                         id="destLoadTimeHrs"
// //                         type="number"
// //                         min="0"
// //                         step="0.01"
// //                         placeholder="0"
// //                         value={form.destLoadTimeHrs || ""}
// //                         readOnly
// //                       />
// //                       <span>hrs</span>
// //                     </div>
// //                     <div className="cost_hint">Capacity baseline: 650 lbs/hr by 2 men (scaled)</div>
// //                   </div>
// //                   <div>
// //                     <label htmlFor="destUnloadTimeHrs">Unloading Time</label>
// //                     <div className="cost_unit">
// //                       <input
// //                         id="destUnloadTimeHrs"
// //                         type="number"
// //                         min="0"
// //                         step="0.01"
// //                         placeholder="0"
// //                         value={form.destUnloadTimeHrs || ""}
// //                         readOnly
// //                       />
// //                       <span>hrs</span>
// //                     </div>
// //                     <div className="cost_hint">Capacity baseline: 850 lbs/hr by 2 men (scaled)</div>
// //                   </div>
// //                   <div>
// //                     <label htmlFor="destUnloadTrailerTimeHrs">Unloading Time (from Trailer)</label>
// //                     <div className="cost_unit">
// //                       <input
// //                         id="destUnloadTrailerTimeHrs"
// //                         type="number"
// //                         min="0"
// //                         step="0.01"
// //                         placeholder="0"
// //                         value={form.destUnloadTrailerTimeHrs || ""}
// //                         readOnly
// //                       />
// //                       <span>hrs</span>
// //                     </div>
// //                     <div className="cost_hint">Additional unload at Destination Hub from trailer</div>
// //                   </div>
// //                   <div>
// //                     <label htmlFor="destDriverCost">Driver Cost</label>
// //                     <div className="cost_unit">
// //                       <input
// //                         id="destDriverCost"
// //                         type="number"
// //                         min="0"
// //                         step="0.01"
// //                         placeholder="0"
// //                         value={form.destDriverCost || ""}
// //                         readOnly
// //                       />
// //                       <span>$</span>
// //                     </div>
// //                     <div className="cost_hint">(Billable + Non-billable + Load + Unload + Unload from Trailer) × $20</div>
// //                   </div>
// //                   <div>
// //                     <label htmlFor="destHelpersCost">Helpers Cost</label>
// //                     <div className="cost_unit">
// //                       <input
// //                         id="destHelpersCost"
// //                         type="number"
// //                         min="0"
// //                         step="0.01"
// //                         placeholder="0"
// //                         value={form.destHelpersCost || ""}
// //                         readOnly
// //                       />
// //                       <span>$</span>
// //                     </div>
// //                     <div className="cost_hint">Per helper: ((All load/unload) × $20 + (Travel × $10)) × helpers</div>
// //                   </div>
// //                   <div>
// //                     <label htmlFor="destTotalLabour">Total Labour Cost</label>
// //                     <div className="cost_unit">
// //                       <input
// //                         id="destTotalLabour"
// //                         type="number"
// //                         min="0"
// //                         step="0.01"
// //                         placeholder="0"
// //                         value={form.destTotalLabour || ""}
// //                         readOnly
// //                       />
// //                       <span>$</span>
// //                     </div>
// //                   </div>
// //                   <div>
// //                     <label htmlFor="destTruckCost">Truck Cost</label>
// //                     <div className="cost_unit">
// //                       <input
// //                         id="destTruckCost"
// //                         type="number"
// //                         min="0"
// //                         step="0.01"
// //                         placeholder="0"
// //                         value={form.destTruckCost || ""}
// //                         readOnly
// //                       />
// //                       <span>$</span>
// //                     </div>
// //                     <div className="cost_hint">From Truck Cost above</div>
// //                   </div>
// //                   <div>
// //                     <label htmlFor="destFuelCost">Fuel Cost (Destination)</label>
// //                     <div className="cost_unit">
// //                       <input
// //                         id="destFuelCost"
// //                         type="number"
// //                         min="0"
// //                         step="0.01"
// //                         placeholder="0"
// //                         value={form.destFuelCost || ""}
// //                         readOnly
// //                       />
// //                       <span>$</span>
// //                     </div>
// //                     <div className="cost_hint">Formula: ((Destination→Stop + Stop→Destination) ÷ 3.5) × 1.7</div>
// //                   </div>
// //                   <div>
// //                     <label htmlFor="destSubtotal">Subtotal (Destination Side)</label>
// //                     <div className="cost_unit">
// //                       <input
// //                         id="destSubtotal"
// //                         type="number"
// //                         min="0"
// //                         step="0.01"
// //                         placeholder="0"
// //                         value={form.destSubtotal || ""}
// //                         readOnly
// //                       />
// //                       <span>$</span>
// //                     </div>
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           )}
// //         </section>

// //         <section className="cost_card">
// //           <div className="cost_row" style={{ justifyContent: "space-between" }}>
// //             <h2 style={{ margin: 0, fontSize: "1.05rem" }}>Results</h2>
// //           </div>
// //           <div className="cost_bar"></div>
// //           {!collapsedSections.results && (
// //             <>
// //               <div className="cost_btns">
// //                 <button onClick={reset}>Re-calculate</button>
// //               </div>
// //               <div className="cost_grid cost_cols-2">
// //                 <div className="cost_out">
// //                   <div className="cost_hint">Estimated Total</div>
// //                   <div className="cost_tot" id="totalCostDisplay">{fmtMoney(totalCost)}</div>
// //                   <div className="cost_note">Live formulas based on your rules.</div>
// //                 </div>
// //                 <div className="cost_out">
// //                   <div className="cost_hint">Breakdown</div>
// //                   <pre style={{ whiteSpace: "pre-wrap", margin: 0 }}>{breakdown}</pre>
// //                 </div>
// //               </div>
// //             </>
// //           )}
// //         </section>
// //       </main>
// //     </div>
// //   );
// // };

// // export default LongMoveCostCalculator;
// import React, { useState, useEffect } from "react";
// import './CostCalculator.css';

// const LongMoveCostCalculator = ({ booking }) => {
//   const MOVE_WEIGHT = {
//     studio: 1500,
//     "1br": 2500,
//     "2br": 4000,
//     "3br": 6000,
//     "4br": 8000,
//   };

//   const MOVE_TRUCK = {
//     studio: "16 ft",
//     "1br": "16–20 ft",
//     "2br": "20–22 ft",
//     "3br": "26 ft",
//     "4br": "26+ ft / 5-ton",
//   };

//   const hubs = [
//     { value: "", label: "" },
//     { value: "43.6532,-79.3832", label: "Toronto Hub" },
//     { value: "49.2827,-123.1207", label: "Vancouver Hub" },
//     { value: "51.0447,-114.0719", label: "Calgary Hub" },
//   ];

//   const moveSizes = [
//     { value: "", label: "Select size…" },
//     { value: "studio", label: "Studio" },
//     { value: "1br", label: "1 Bedroom" },
//     { value: "2br", label: "2 Bedroom" },
//     { value: "3br", label: "3 Bedroom" },
//     { value: "4br", label: "4 Bedroom" },
//   ];

//   const normalizeMoveSize = (moveSize) => {
//     const moveSizeMap = {
//       Studio: "studio",
//       "1 Bedroom": "1br",
//       "2 Bedroom": "2br",
//       "3 Bedroom": "3br",
//       "4 Bedroom": "4br",
//     };
//     return moveSizeMap[moveSize] || moveSize.toLowerCase();
//   };

//   const parseMoveSize = (input) => {
//     if (!input) return { moveSize: "", weight: "" };
//     const match = input.match(/(.*?)(\d+)\s*lbs$/i);
//     if (match) {
//       const rawSize = match[1].trim();
//       const weight = match[2];
//       const normalizedSize = normalizeMoveSize(rawSize);
//       return { moveSize: normalizedSize, weight };
//     } else {
//       return { moveSize: normalizeMoveSize(input), weight: "" };
//     }
//   };

//   const getStaircaseFee = (stairs) => {
//     if (stairs >= 40) return 600;
//     if (stairs >= 30 && stairs < 40) return 450;
//     if (stairs >= 20 && stairs < 30) return 300;
//     if (stairs >= 10 && stairs < 20) return 150;
//     return 0;
//   };

//   const getLongWalkCharges = (yards) => {
//     if (yards >= 150) return 300;
//     if (yards >= 100 && yards < 150) return 250;
//     if (yards >= 50 && yards < 100) return 200;
//     if (yards >= 40 && yards < 50) return 150;
//     return 0;
//   };

//   const [form, setForm] = useState({
//     startingHub: "",
//     moveDate: booking?.Move_Date || "",
//     origin: booking?.FromAddress || booking?.OriginCity || "",
//     destination: booking?.ToAddress || booking?.DestinationCity || "",
//     staircaseFee: "",
//     longWalkCharges: "",
//     stopHub: "",
//     km1: "", // Start → Origin
//     km2: "", // Origin → Start
//     km3: "", // Destination → Stop
//     km4: "", // Stop → Destination
//     origBillTimeHrs: "",
//     origNonBillTimeHrs: "",
//     origLoadTimeHrs: "",
//     origUnloadTimeHrs: "",
//     origLoadTrailerTimeHrs: "",
//     destBillTimeHrs: "",
//     destNonBillTimeHrs: "",
//     destLoadTimeHrs: "",
//     destUnloadTimeHrs: "",
//     destUnloadTrailerTimeHrs: "",
//     origDriverCost: "",
//     origHelpersCost: "",
//     origTotalLabour: "",
//     origTruckCost: "",
//     origFuelCost: "",
//     origSubtotal: "",
//     transTrailerCost: "",
//     transSubtotal: "",
//     destDriverCost: "",
//     destHelpersCost: "",
//     destTotalLabour: "",
//     destTruckCost: "",
//     destFuelCost: "",
//     destSubtotal: "",
//     moveSize: "",
//     estWeightLbs: "",
//     truckSize: "",
//     numMen: "2",
//     truckCost: "200",
//     subTotal: "",
//     leadCost: "0",
//     opsExpense: "0",
//     profitPct: "50",
//     ACVLSplitPct: "50",
//     vendorsplitPct: "50",
//   });

//   const [distanceStatus, setDistanceStatus] = useState(
//     "Enter all locations to fetch distances and times."
//   );
//   const [totalCost, setTotalCost] = useState(0);
//   const [breakdown, setBreakdown] = useState("");
//   const [apiKey, setApiKey] = useState("");
//   const [isDistanceFetched, setIsDistanceFetched] = useState(false);
//   const [isFetching, setIsFetching] = useState(false);
//   const [collapsedSections, setCollapsedSections] = useState({
//     jobDetails: true,
//     moveDetails: true,
//     distanceCost: true,
//     results: false,
//   });

//   useEffect(() => {
//     const fetchApiKey = async () => {
//       try {
//         const response = await fetch("https://salesjet-10097049716.catalystappsail.com/api/get-google-api-key");
//         const data = await response.json();
//         setApiKey(data.apiKey);
//       } catch (error) {
//         console.error("Failed to fetch API key:", error);
//         setDistanceStatus("Error fetching API key.");
//       }
//     };

//     fetchApiKey();

//     const { moveSize: normalizedMoveSize, weight } = parseMoveSize(booking?.Move_Size);
//     const totalStairs = parseInt(booking?.NoOfStaircasesAtOrigin || 0) + parseInt(booking?.NoOfStaircasesAtDestination || 0);
//     const staircaseFee = getStaircaseFee(totalStairs);
//     const totalYards = parseFloat(booking?.LongWalkAtOrigin || 0) + parseFloat(booking?.LongWalkAtDestination || 0);
//     const longWalkCharges = getLongWalkCharges(totalYards);
//     const updates = {
//       origin: booking?.FromAddress || booking?.OriginCity || "",
//       destination: booking?.ToAddress || booking?.DestinationCity || "",
//       moveSize: normalizedMoveSize,
//       estWeightLbs: weight || (normalizedMoveSize ? MOVE_WEIGHT[normalizedMoveSize] || "" : ""),
//       truckSize: normalizedMoveSize ? MOVE_TRUCK[normalizedMoveSize] || "" : "",
//       staircaseFee: staircaseFee.toFixed(2),
//       longWalkCharges: longWalkCharges.toFixed(2),
//       origTruckCost: "200",
//       destTruckCost: "200",
//     };
//     setForm((prev) => ({ ...prev, ...updates }));
//     if (normalizedMoveSize || weight) {
//       calculate();
//     }
//   }, [booking]);

//   useEffect(() => {
//     if (
//       form.km1 ||
//       form.km2 ||
//       form.km3 ||
//       form.km4 ||
//       form.origBillTimeHrs ||
//       form.origNonBillTimeHrs ||
//       form.destBillTimeHrs ||
//       form.destNonBillTimeHrs ||
//       form.estWeightLbs ||
//       form.numMen ||
//       form.truckCost ||
//       form.profitPct ||
//       form.ACVLSplitPct ||
//       form.staircaseFee ||
//       form.longWalkCharges
//     ) {
//       calculate();
//     }
//   }, [
//     form.km1,
//     form.km2,
//     form.km3,
//     form.km4,
//     form.origBillTimeHrs,
//     form.origNonBillTimeHrs,
//     form.destBillTimeHrs,
//     form.destNonBillTimeHrs,
//     form.estWeightLbs,
//     form.numMen,
//     form.truckCost,
//     form.profitPct,
//     form.ACVLSplitPct,
//     form.staircaseFee,
//     form.longWalkCharges,
//   ]);

//   const fmtMoney = (v) =>
//     isFinite(v) ? (v < 0 ? "-$" : "$") + Math.abs(v).toFixed(2) : "$0.00";

//   const updateForm = (updates) => {
//     setForm((prev) => {
//       const newForm = { ...prev, ...updates };
//       if (updates.ACVLSplitPct !== undefined) {
//         newForm.vendorsplitPct = (100 - parseFloat(updates.ACVLSplitPct || 0)).toString();
//       }
//       return newForm;
//     });
//   };

//   const calculate = () => {
//     const w = parseFloat(form.estWeightLbs) || 0;
//     const men = Math.max(1, parseInt(form.numMen || 0));
//     const crewFactor = men / 2;
//     const km1 = parseFloat(form.km1) || 0;
//     const km2 = parseFloat(form.km2) || 0;
//     const km3 = parseFloat(form.km3) || 0;
//     const km4 = parseFloat(form.km4) || 0;
//     const truckCost = parseFloat(form.truckCost) || 200;
//     const origBillTime = parseFloat(form.origBillTimeHrs) || 0;
//     const origNonBillTime = parseFloat(form.origNonBillTimeHrs) || 0;
//     const destBillTime = parseFloat(form.destBillTimeHrs) || 0;
//     const destNonBillTime = parseFloat(form.destNonBillTimeHrs) || 0;
//     const staircaseFee = parseFloat(form.staircaseFee) || 0;
//     const longWalkCharges = parseFloat(form.longWalkCharges) || 0;

//     // Origin Side Calculations
//     const origLoadTime = crewFactor > 0 ? w / (650 * crewFactor) : 0;
//     const origUnloadTime = crewFactor > 0 ? w / (850 * crewFactor) : 0;
//     const origLoadTrailerTime = crewFactor > 0 ? w / (650 * crewFactor) : 0;
//     const origDriverCost = (origBillTime + origNonBillTime + origLoadTime + origUnloadTime + origLoadTrailerTime) * 20;
//     const origHelpers = Math.max(0, men - 1);
//     const origHelperPer = (origLoadTime + origUnloadTime + origLoadTrailerTime) * 20 + (origBillTime + origNonBillTime) * 10;
//     const origHelpersCost = origHelpers * origHelperPer;
//     const origTotalLabour = origDriverCost + origHelpersCost;
//     const origFuelCost = ((km1 + km2) / 3.5) * 1.7;
//     const origSubtotal = origTotalLabour + truckCost + origFuelCost;

//     // Transit Calculations
//     const transTrailerCost = w * 0.55;
//     const transSubtotal = transTrailerCost;

//     // Destination Side Calculations
//     const destLoadTime = crewFactor > 0 ? w / (650 * crewFactor) : 0;
//     const destUnloadTime = crewFactor > 0 ? w / (850 * crewFactor) : 0;
//     const destUnloadTrailerTime = crewFactor > 0 ? w / (850 * crewFactor) : 0;
//     const destDriverCost = (destBillTime + destNonBillTime + destLoadTime + destUnloadTime + destUnloadTrailerTime) * 20;
//     const destHelpers = Math.max(0, men - 1);
//     const destHelperPer = (destLoadTime + destUnloadTime + destUnloadTrailerTime) * 20 + (destBillTime + destNonBillTime) * 10;
//     const destHelpersCost = destHelpers * destHelperPer;
//     const destTotalLabour = destDriverCost + destHelpersCost;
//     const destFuelCost = ((km3 + km4) / 3.5) * 1.7;
//     const destSubtotal = destTotalLabour + truckCost + destFuelCost;

//     // Fixed Costs
//     const subTotal = origSubtotal + transSubtotal + destSubtotal + staircaseFee + longWalkCharges;
//     const leadCost = subTotal * 0.05;
//     const opsExpense = subTotal * 0.10;
//     const profitPct = (parseFloat(form.profitPct) || 0) / 100;
//     const acvlSplitPct = (parseFloat(form.ACVLSplitPct) || 0) / 100;
//     const vendorSplitPct = (parseFloat(form.vendorsplitPct) || 0) / 100;
//     const profitBase = subTotal + leadCost + opsExpense;
//     const profit = profitBase * profitPct;
//     const total = profitBase + profit;
//     const acvlProfit = profit * acvlSplitPct;
//     const vendorProfit = profit * vendorSplitPct;

//     updateForm({
//       origLoadTimeHrs: origLoadTime.toFixed(2),
//       origUnloadTimeHrs: origUnloadTime.toFixed(2),
//       origLoadTrailerTimeHrs: origLoadTrailerTime.toFixed(2),
//       origDriverCost: origDriverCost.toFixed(2),
//       origHelpersCost: origHelpersCost.toFixed(2),
//       origTotalLabour: origTotalLabour.toFixed(2),
//       origTruckCost: truckCost.toFixed(2),
//       origFuelCost: origFuelCost.toFixed(2),
//       origSubtotal: origSubtotal.toFixed(2),
//       transTrailerCost: transTrailerCost.toFixed(2),
//       transSubtotal: transSubtotal.toFixed(2),
//       destLoadTimeHrs: destLoadTime.toFixed(2),
//       destUnloadTimeHrs: destUnloadTime.toFixed(2),
//       destUnloadTrailerTimeHrs: destUnloadTrailerTime.toFixed(2),
//       destDriverCost: destDriverCost.toFixed(2),
//       destHelpersCost: destHelpersCost.toFixed(2),
//       destTotalLabour: destTotalLabour.toFixed(2),
//       destTruckCost: truckCost.toFixed(2),
//       destFuelCost: destFuelCost.toFixed(2),
//       destSubtotal: destSubtotal.toFixed(2),
//       subTotal: subTotal.toFixed(2),
//       leadCost: leadCost.toFixed(2),
//       opsExpense: opsExpense.toFixed(2),
//     });

//     setTotalCost(total);
//     setBreakdown(
//       `Origin Side:
//   Billable Travel Time: ${origBillTime.toFixed(2)} hrs
//   Non-Billable Travel Time: ${origNonBillTime.toFixed(2)} hrs
//   Loading: ${origLoadTime.toFixed(2)} hrs
//   Unloading: ${origUnloadTime.toFixed(2)} hrs
//   Loading into Trailer: ${origLoadTrailerTime.toFixed(2)} hrs
//   Driver: ${fmtMoney(origDriverCost)}
//   Helpers: ${fmtMoney(origHelpersCost)}
//   Truck: ${fmtMoney(truckCost)}
//   Fuel: ${fmtMoney(origFuelCost)}
//   Subtotal (Origin): ${fmtMoney(origSubtotal)}
// Transit:
//   Trailer Transit: ${fmtMoney(transTrailerCost)}
//   Subtotal (Transit): ${fmtMoney(transSubtotal)}
// Destination Side:
//   Billable Travel Time: ${destBillTime.toFixed(2)} hrs
//   Non-Billable Travel Time: ${destNonBillTime.toFixed(2)} hrs
//   Loading: ${destLoadTime.toFixed(2)} hrs
//   Unloading: ${destUnloadTime.toFixed(2)} hrs
//   Unloading from Trailer: ${destUnloadTrailerTime.toFixed(2)} hrs
//   Driver: ${fmtMoney(destDriverCost)}
//   Helpers: ${fmtMoney(destHelpersCost)}
//   Truck: ${fmtMoney(truckCost)}
//   Fuel: ${fmtMoney(destFuelCost)}
//   Subtotal (Dest): ${fmtMoney(destSubtotal)}
// Totals:
//   Local Labour (Origin+Dest): ${fmtMoney(origTotalLabour + destTotalLabour)}
//   Total Fuel: ${fmtMoney(origFuelCost + destFuelCost)}
//   Trailer Transit: ${fmtMoney(transTrailerCost)}
//   Stairs: ${fmtMoney(staircaseFee)}
//   Long Walk: ${fmtMoney(longWalkCharges)}
//   SubTotal: ${fmtMoney(subTotal)}
//   Lead (5%): ${fmtMoney(leadCost)}
//   Ops (10%): ${fmtMoney(opsExpense)}
//   Profit (${form.profitPct || 0}%): ${fmtMoney(profit)}
//     ACVL (${form.ACVLSplitPct || 0}%): ${fmtMoney(acvlProfit)}
//     Vendor (${form.vendorsplitPct || 0}%): ${fmtMoney(vendorProfit)}
// Grand Total: ${fmtMoney(total)}`
//     );
//   };

//   const fetchDistances = async () => {
//     setDistanceStatus('Looking up distances and times…');
//     setIsFetching(true);
//     setIsDistanceFetched(false);
//     try {
//       const { startingHub, stopHub, origin, destination } = form;
//       if (!(startingHub && stopHub && origin && destination)) {
//         setDistanceStatus('Please fill Starting Hub, Stop Hub, Origin, and Destination.');
//         setIsFetching(false);
//         return;
//       }

//       const response = await fetch('https://salesjet-10097049716.catalystappsail.com/api/long-calculate-distances', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ startingHub, stopHub, origin, destination }),
//       });

//       if (!response.ok) {
//         throw new Error('Failed to fetch distances from server.');
//       }

//       const {
//         km1,
//         km2,
//         km3,
//         km4,
//         billableKm,
//         origBillTimeHrs,
//         origNonBillTimeHrs,
//         destBillTimeHrs,
//         destNonBillTimeHrs,
//         billableTimeHrs,
//       } = await response.json();

//       console.log('Fetched data:', {
//         km1,
//         km2,
//         km3,
//         km4,
//         billableKm,
//         origBillTimeHrs,
//         origNonBillTimeHrs,
//         destBillTimeHrs,
//         destNonBillTimeHrs,
//         billableTimeHrs,
//       });

//       updateForm({
//         km1,
//         km2,
//         km3,
//         km4,
//         origBillTimeHrs,
//         origNonBillTimeHrs,
//         destBillTimeHrs,
//         destNonBillTimeHrs,
//       });

//       setTimeout(() => calculate(), 0); // Ensure updateForm completes
//       setIsDistanceFetched(true);
//       setDistanceStatus(
//         `Updated ✓ Legs: ${km1} km (${origBillTimeHrs} hrs), ${km2} km (${origNonBillTimeHrs} hrs), ${km3} km (${destBillTimeHrs} hrs), ${km4} km (${destNonBillTimeHrs} hrs) | Billable: ${billableKm} km (${billableTimeHrs} hrs)`
//       );
//     } catch (err) {
//       console.error(err);
//       setDistanceStatus('Distance and time lookup failed. Check locations or try again.');
//       setIsDistanceFetched(false);
//     } finally {
//       setIsFetching(false);
//     }
//   };

//   const reset = () => {
//     const { moveSize: normalizedMoveSize, weight } = parseMoveSize(booking?.Move_Size);
//     const totalStairs = parseInt(booking?.NoOfStaircasesAtOrigin || 0) + parseInt(booking?.NoOfStaircasesAtDestination || 0);
//     const staircaseFee = getStaircaseFee(totalStairs);
//     const totalYards = parseFloat(booking?.LongWalkAtOrigin || 0) + parseFloat(booking?.LongWalkAtDestination || 0);
//     const longWalkCharges = getLongWalkCharges(totalYards);
//     setForm({
//       startingHub: "",
//       moveDate: booking?.Move_Date || "",
//       origin: booking?.FromAddress || booking?.OriginCity || "",
//       destination: booking?.ToAddress || booking?.DestinationCity || "",
//       stopHub: "",
//       km1: "",
//       km2: "",
//       km3: "",
//       km4: "",
//       origBillTimeHrs: "",
//       origNonBillTimeHrs: "",
//       origLoadTimeHrs: "",
//       origUnloadTimeHrs: "",
//       origLoadTrailerTimeHrs: "",
//       destBillTimeHrs: "",
//       destNonBillTimeHrs: "",
//       destLoadTimeHrs: "",
//       destUnloadTimeHrs: "",
//       destUnloadTrailerTimeHrs: "",
//       origDriverCost: "",
//       origHelpersCost: "",
//       origTotalLabour: "",
//       origTruckCost: "200",
//       origFuelCost: "",
//       origSubtotal: "",
//       transTrailerCost: "",
//       transSubtotal: "",
//       destDriverCost: "",
//       destHelpersCost: "",
//       destTotalLabour: "",
//       destTruckCost: "200",
//       destFuelCost: "",
//       destSubtotal: "",
//       moveSize: normalizedMoveSize,
//       estWeightLbs: weight || (normalizedMoveSize ? MOVE_WEIGHT[normalizedMoveSize] || "" : ""),
//       truckSize: normalizedMoveSize ? MOVE_TRUCK[normalizedMoveSize] || "" : "",
//       numMen: "2",
//       truckCost: "200",
//       subTotal: "",
//       leadCost: "0",
//       opsExpense: "0",
//       profitPct: "50",
//       ACVLSplitPct: "50",
//       vendorsplitPct: "50",
//       staircaseFee: staircaseFee.toFixed(2),
//       longWalkCharges: longWalkCharges.toFixed(2),
//     });
//     setDistanceStatus("Enter all locations to fetch distances and times.");
//     setTotalCost(0);
//     setBreakdown("");
//     setIsDistanceFetched(false);
//     setIsFetching(false);
//     setCollapsedSections({
//       jobDetails: false,
//       moveDetails: false,
//       distanceCost: false,
//       results: false,
//     });
//   };

//   const toggleSection = (section) => {
//     setCollapsedSections((prev) => ({
//       ...prev,
//       [section]: !prev[section],
//     }));
//   };

//   const SelectField = ({ id, label, options, hint, onChange }) => (
//     <div>
//       <label htmlFor={id}>{label}</label>
//       <select
//         id={id}
//         value={form[id] || ""}
//         onChange={onChange || ((e) => updateForm({ [id]: e.target.value }))}
//       >
//         {options.map((opt) => (
//           <option key={opt.value} value={opt.value}>{opt.label}</option>
//         ))}
//       </select>
//       {hint && <div className="cost_hint">{hint}</div>}
//     </div>
//   );

//   const ComboField = ({ id, label, options, hint }) => (
//     <div>
//       <label htmlFor={id}>{label}</label>
//       <input
//         id={id}
//         type="text"
//         list={`${id}-datalist`}
//         value={form[id] || ""}
//         onChange={(e) => updateForm({ [id]: e.target.value })}
//         placeholder="Type location or select hub..."
//       />
//       <datalist id={`${id}-datalist`}>
//         {options.map((opt) => (
//           <option key={opt.value} value={opt.value}>
//             {opt.label}
//           </option>
//         ))}
//       </datalist>
//       {hint && <div className="cost_hint">{hint}</div>}
//     </div>
//   );

//   return (
//     <div className="cost_wrap">
//       <main className="cost_wrap">
//         <section className="cost_card">
//           <div className="cost_row" style={{ justifyContent: "space-between" }}>
//             <h2 style={{ margin: 0, fontSize: "1.05rem" }}>Job Details</h2>
//             <div style={{ display: "flex", alignItems: "center" }}>
//               <span className="cost_pill">All distances in KM • Times from Google Maps</span>
//               <button
//                 onClick={() => toggleSection("jobDetails")}
//                 style={{
//                   marginLeft: "10px",
//                   fontSize: "1.2rem",
//                   cursor: "pointer",
//                   color: "#333",
//                   border: "none",
//                   background: "none",
//                 }}
//               >
//                 {collapsedSections.jobDetails ? "+" : "−"}
//               </button>
//             </div>
//           </div>
//           <div className="cost_bar"></div>
//           {!collapsedSections.jobDetails && (
//             <div className="cost_grid cost_cols-3">
//               <div>
//                 <label htmlFor="origin">Origin (City, Province)</label>
//                 <div className="cost_unit">
//                   <input
//                     id="origin"
//                     type="text"
//                     placeholder="City, ST, Country or lat,lon"
//                     value={form.origin || ""}
//                     onChange={(e) => updateForm({ origin: e.target.value })}
//                   />
//                 </div>
//               </div>
//               <div>
//                 <label htmlFor="destination">Destination (City, Province)</label>
//                 <div className="cost_unit">
//                   <input
//                     id="destination"
//                     type="text"
//                     placeholder="City, ST, Country or lat,lon"
//                     value={form.destination || ""}
//                     onChange={(e) => updateForm({ destination: e.target.value })}
//                   />
//                 </div>
//               </div>
//               <div>
//                 <label htmlFor="moveDate">Move Date</label>
//                 <div className="cost_unit">
//                   <input
//                     id="moveDate"
//                     type="text"
//                     placeholder="YYYY-MM-DD"
//                     value={form.moveDate || ""}
//                     onChange={(e) => updateForm({ moveDate: e.target.value })}
//                   />
//                 </div>
//               </div>
//               <div>
//                 <label htmlFor="moveSize">Move Size (Bedrooms)</label>
//                 <div className="cost_unit">
//                   <input
//                     id="moveSize"
//                     type="text"
//                     placeholder="Select size…"
//                     value={moveSizes.find(opt => opt.value === form.moveSize)?.label || form.moveSize || ""}
//                     readOnly
//                   />
//                 </div>
//               </div>
//             </div>
//           )}
//         </section>

//         <section className="cost_card">
//           <div className="cost_row" style={{ justifyContent: "space-between" }}>
//             <h2 style={{ margin: 0, fontSize: "1.05rem" }}>Move Details & Profit Range</h2>
//             <button
//               onClick={() => toggleSection("moveDetails")}
//               style={{
//                 fontSize: "1.2rem",
//                 cursor: "pointer",
//                 color: "#333",
//                 border: "none",
//                 background: "none",
//               }}
//             >
//               {collapsedSections.moveDetails ? "+" : "−"}
//             </button>
//           </div>
//           <div className="cost_bar"></div>
//           {!collapsedSections.moveDetails && (
//             <>
//               <div className="cost_grid cost_cols-3">
//                 <ComboField
//                   id="startingHub"
//                   label="Starting Location (Hub)"
//                   options={hubs}
//                 />
//                 <ComboField
//                   id="stopHub"
//                   label="Stop Location (Hub)"
//                   options={hubs}
//                 />
//               </div>
//               <div className="cost_btns" style={{ marginTop: "8px", position: "relative" }}>
//                 <button
//                   type="button"
//                   onClick={fetchDistances}
//                   className={isDistanceFetched ? "cost_fetched" : isFetching ? "cost_fetching" : ""}
//                 >
//                   Fetch distances and times (Google Maps)
//                   {isFetching && (
//                     <span className="spinner" style={{ marginLeft: "8px" }}>↻</span>
//                   )}
//                 </button>
//               </div>
//               <div className="cost_grid cost_cols-3" style={{ marginTop: "10px" }}>
//                 <div>
//                   <label htmlFor="estWeightLbs">Estimated Weight</label>
//                   <div className="cost_unit">
//                     <input
//                       id="estWeightLbs"
//                       type="number"
//                       min="0"
//                       step="1"
//                       placeholder="0"
//                       value={form.estWeightLbs || ""}
//                       onChange={(e) => {
//                         updateForm({ estWeightLbs: e.target.value });
//                         calculate();
//                       }}
//                     />
//                     <span>lbs</span>
//                   </div>
//                 </div>
//                 <div>
//                   <label htmlFor="truckSize">Truck Size</label>
//                   <div className="cost_unit">
//                     <input
//                       id="truckSize"
//                       type="text"
//                       placeholder="e.g., 16 ft / 20 ft / 26 ft"
//                       value={form.truckSize || ""}
//                       onChange={(e) => updateForm({ truckSize: e.target.value })}
//                     />
//                   </div>
//                 </div>
//                 <div>
//                   <label htmlFor="numMen">Number of Men</label>
//                   <div className="cost_unit">
//                     <input
//                       id="numMen"
//                       type="number"
//                       min="1"
//                       step="1"
//                       placeholder="2"
//                       value={form.numMen || ""}
//                       onChange={(e) => {
//                         updateForm({ numMen: e.target.value });
//                         calculate();
//                       }}
//                     />
//                   </div>
//                 </div>
//                 <div>
//                   <label htmlFor="truckCost">Truck Cost</label>
//                   <div className="cost_unit">
//                     <input
//                       id="truckCost"
//                       type="number"
//                       min="0"
//                       step="0.01"
//                       placeholder="200"
//                       value={form.truckCost || ""}
//                       onChange={(e) => {
//                         updateForm({ truckCost: e.target.value, origTruckCost: e.target.value, destTruckCost: e.target.value });
//                         calculate();
//                       }}
//                     />
//                     <span>$</span>
//                   </div>
//                   <div className="cost_hint">Enter truck rental or usage cost manually.</div>
//                 </div>
//                 <div>
//                   <label htmlFor="profitPct">Profit Percentage</label>
//                   <div className="cost_unit">
//                     <input
//                       id="profitPct"
//                       type="number"
//                       min="0"
//                       step="0.1"
//                       placeholder="50"
//                       value={form.profitPct || ""}
//                       onChange={(e) => {
//                         updateForm({ profitPct: e.target.value });
//                       }}
//                     />
//                     <span>%</span>
//                   </div>
//                   <div className="cost_hint">Applied to (Sub-Total + Lead + Ops)</div>
//                 </div>
//                 <div>
//                   <label htmlFor="ACVLSplitPct">ACVL Profit Split</label>
//                   <div className="cost_unit">
//                     <input
//                       id="ACVLSplitPct"
//                       type="number"
//                       min="0"
//                       max="100"
//                       step="0.1"
//                       placeholder="50"
//                       value={form.ACVLSplitPct || ""}
//                       onChange={(e) => {
//                         updateForm({ ACVLSplitPct: e.target.value });
//                       }}
//                     />
//                     <span>%</span>
//                   </div>
//                 </div>
//                 <div>
//                   <label htmlFor="vendorsplitPct">Vendor Profit Split</label>
//                   <div className="cost_unit">
//                     <input
//                       id="vendorsplitPct"
//                       type="number"
//                       min="0"
//                       max="100"
//                       step="0.1"
//                       placeholder="50"
//                       value={form.vendorsplitPct || ""}
//                       readOnly
//                     />
//                     <span>%</span>
//                   </div>
//                 </div>
//               </div>
//             </>
//           )}
//         </section>

//         <section className="cost_card">
//           <div className="cost_row" style={{ justifyContent: "space-between" }}>
//             <h2 style={{ margin: 0, fontSize: "1.05rem" }}>Detailed Cost Breakdown</h2>
//             <button
//               onClick={() => toggleSection("distanceCost")}
//               style={{
//                 fontSize: "1.2rem",
//                 cursor: "pointer",
//                 border: "none",
//                 color: "#333",
//                 background: "none",
//               }}
//             >
//               {collapsedSections.distanceCost ? "+" : "−"}
//             </button>
//           </div>
//           <div className="cost_bar"></div>
//           {!collapsedSections.distanceCost && (
//             <div>
//               {/* Origin Side */}
//               <div style={{ marginBottom: "12px" }}>
//                 <h5 style={{ margin: "0.2rem 0" }}>Origin Side Cost</h5>
//                 <div className="cost_bar"></div>
//                 <div className="cost_grid cost_cols-3">
//                   <div>
//                     <label htmlFor="km1">Start → Origin (km)</label>
//                     <div className="cost_unit">
//                       <input
//                         id="km1"
//                         type="number"
//                         min="0"
//                         step="0.1"
//                         placeholder="0"
//                         value={form.km1 || ""}
//                         onChange={(e) => {
//                           updateForm({ km1: e.target.value });
//                           calculate();
//                         }}
//                       />
//                       <span>km</span>
//                     </div>
//                   </div>
//                   <div>
//                     <label htmlFor="km2">Origin → Start (km)</label>
//                     <div className="cost_unit">
//                       <input
//                         id="km2"
//                         type="number"
//                         min="0"
//                         step="0.1"
//                         placeholder="0"
//                         value={form.km2 || ""}
//                         onChange={(e) => {
//                           updateForm({ km2: e.target.value });
//                           calculate();
//                         }}
//                       />
//                       <span>km</span>
//                     </div>
//                   </div>
//                   <div>
//                     <label htmlFor="origBillTimeHrs">Billable Travel Time</label>
//                     <div className="cost_unit">
//                       <input
//                         id="origBillTimeHrs"
//                         type="number"
//                         min="0"
//                         step="0.01"
//                         placeholder="0"
//                         value={form.origBillTimeHrs || ""}
//                         readOnly
//                       />
//                       <span>hrs</span>
//                     </div>
//                     <div className="cost_hint">Fetched from Google Maps</div>
//                   </div>
//                   <div>
//                     <label htmlFor="origNonBillTimeHrs">Non-Billable Travel Time</label>
//                     <div className="cost_unit">
//                       <input
//                         id="origNonBillTimeHrs"
//                         type="number"
//                         min="0"
//                         step="0.01"
//                         placeholder="0"
//                         value={form.origNonBillTimeHrs || ""}
//                         readOnly
//                       />
//                       <span>hrs</span>
//                     </div>
//                     <div className="cost_hint">Fetched from Google Maps</div>
//                   </div>
//                   <div>
//                     <label htmlFor="origLoadTimeHrs">Loading Time</label>
//                     <div className="cost_unit">
//                       <input
//                         id="origLoadTimeHrs"
//                         type="number"
//                         min="0"
//                         step="0.01"
//                         placeholder="0"
//                         value={form.origLoadTimeHrs || ""}
//                         readOnly
//                       />
//                       <span>hrs</span>
//                     </div>
//                     <div className="cost_hint">Capacity baseline: 650 lbs/hr by 2 men (scaled)</div>
//                   </div>
//                   <div>
//                     <label htmlFor="origUnloadTimeHrs">Unloading Time</label>
//                     <div className="cost_unit">
//                       <input
//                         id="origUnloadTimeHrs"
//                         type="number"
//                         min="0"
//                         step="0.01"
//                         placeholder="0"
//                         value={form.origUnloadTimeHrs || ""}
//                         readOnly
//                       />
//                       <span>hrs</span>
//                     </div>
//                     <div className="cost_hint">Capacity baseline: 850 lbs/hr by 2 men (scaled)</div>
//                   </div>
//                   <div>
//                     <label htmlFor="origLoadTrailerTimeHrs">Loading Time (into Trailer)</label>
//                     <div className="cost_unit">
//                       <input
//                         id="origLoadTrailerTimeHrs"
//                         type="number"
//                         min="0"
//                         step="0.01"
//                         placeholder="0"
//                         value={form.origLoadTrailerTimeHrs || ""}
//                         readOnly
//                       />
//                       <span>hrs</span>
//                     </div>
//                     <div className="cost_hint">Additional load at Origin Hub into trailer</div>
//                   </div>
//                   <div>
//                     <label htmlFor="origDriverCost">Driver Cost</label>
//                     <div className="cost_unit">
//                       <input
//                         id="origDriverCost"
//                         type="number"
//                         min="0"
//                         step="0.01"
//                         placeholder="0"
//                         value={form.origDriverCost || ""}
//                         readOnly
//                       />
//                       <span>$</span>
//                     </div>
//                     <div className="cost_hint">(Billable + Non-billable + Load + Unload + Load into Trailer) × $20</div>
//                   </div>
//                   <div>
//                     <label htmlFor="origHelpersCost">Helpers Cost</label>
//                     <div className="cost_unit">
//                       <input
//                         id="origHelpersCost"
//                         type="number"
//                         min="0"
//                         step="0.01"
//                         placeholder="0"
//                         value={form.origHelpersCost || ""}
//                         readOnly
//                       />
//                       <span>$</span>
//                     </div>
//                     <div className="cost_hint">Per helper: ((All load/unload) × $20 + (Travel × $10)) × helpers</div>
//                   </div>
//                   <div>
//                     <label htmlFor="origTotalLabour">Total Labour Cost</label>
//                     <div className="cost_unit">
//                       <input
//                         id="origTotalLabour"
//                         type="number"
//                         min="0"
//                         step="0.01"
//                         placeholder="0"
//                         value={form.origTotalLabour || ""}
//                         readOnly
//                       />
//                       <span>$</span>
//                     </div>
//                   </div>
//                   <div>
//                     <label htmlFor="origTruckCost">Truck Cost</label>
//                     <div className="cost_unit">
//                       <input
//                         id="origTruckCost"
//                         type="number"
//                         min="0"
//                         step="0.01"
//                         placeholder="0"
//                         value={form.origTruckCost || ""}
//                         readOnly
//                       />
//                       <span>$</span>
//                     </div>
//                     <div className="cost_hint">From Truck Cost above</div>
//                   </div>
//                   <div>
//                     <label htmlFor="origFuelCost">Fuel Cost (Origin)</label>
//                     <div className="cost_unit">
//                       <input
//                         id="origFuelCost"
//                         type="number"
//                         min="0"
//                         step="0.01"
//                         placeholder="0"
//                         value={form.origFuelCost || ""}
//                         readOnly
//                       />
//                       <span>$</span>
//                     </div>
//                     <div className="cost_hint">Formula: ((Start→Origin + Origin→Start) ÷ 3.5) × 1.7</div>
//                   </div>
//                   <div>
//                     <label htmlFor="origSubtotal">Subtotal (Origin Side)</label>
//                     <div className="cost_unit">
//                       <input
//                         id="origSubtotal"
//                         type="number"
//                         min="0"
//                         step="0.01"
//                         placeholder="0"
//                         value={form.origSubtotal || ""}
//                         readOnly
//                       />
//                       <span>$</span>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Transit */}
//               <div style={{ marginBottom: "12px" }}>
//                 <h5 style={{ margin: "0.2rem 0" }}>Transit</h5>
//                 <div className="cost_bar"></div>
//                 <div className="cost_grid cost_cols-3">
//                   <div>
//                     <label htmlFor="transTrailerCost">Trailer Transit Cost</label>
//                     <div className="cost_unit">
//                       <input
//                         id="transTrailerCost"
//                         type="number"
//                         min="0"
//                         step="0.01"
//                         placeholder="0"
//                         value={form.transTrailerCost || ""}
//                         readOnly
//                       />
//                       <span>$</span>
//                     </div>
//                     <div className="cost_hint">Formula: Weight (lbs) × 0.55</div>
//                   </div>
//                   <div>
//                     <label htmlFor="transSubtotal">Transit Subtotal</label>
//                     <div className="cost_unit">
//                       <input
//                         id="transSubtotal"
//                         type="number"
//                         min="0"
//                         step="0.01"
//                         placeholder="0"
//                         value={form.transSubtotal || ""}
//                         readOnly
//                       />
//                       <span>$</span>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Destination Side */}
//               <div>
//                 <h5 style={{ margin: "0.2rem 0" }}>Destination Side Cost</h5>
//                 <div className="cost_bar"></div>
//                 <div className="cost_grid cost_cols-3">
//                   <div>
//                     <label htmlFor="km3">Destination → Stop (km)</label>
//                     <div className="cost_unit">
//                       <input
//                         id="km3"
//                         type="number"
//                         min="0"
//                         step="0.1"
//                         placeholder="0"
//                         value={form.km3 || ""}
//                         onChange={(e) => {
//                           updateForm({ km3: e.target.value });
//                           calculate();
//                         }}
//                       />
//                       <span>km</span>
//                     </div>
//                   </div>
//                   <div>
//                     <label htmlFor="km4">Stop → Destination (km)</label>
//                     <div className="cost_unit">
//                       <input
//                         id="km4"
//                         type="number"
//                         min="0"
//                         step="0.1"
//                         placeholder="0"
//                         value={form.km4 || ""}
//                         onChange={(e) => {
//                           updateForm({ km4: e.target.value });
//                           calculate();
//                         }}
//                       />
//                       <span>km</span>
//                     </div>
//                   </div>
//                   <div>
//                     <label htmlFor="destBillTimeHrs">Billable Travel Time</label>
//                     <div className="cost_unit">
//                       <input
//                         id="destBillTimeHrs"
//                         type="number"
//                         min="0"
//                         step="0.01"
//                         placeholder="0"
//                         value={form.destBillTimeHrs || ""}
//                         readOnly
//                       />
//                       <span>hrs</span>
//                     </div>
//                     <div className="cost_hint">Fetched from Google Maps</div>
//                   </div>
//                   <div>
//                     <label htmlFor="destNonBillTimeHrs">Non-Billable Travel Time</label>
//                     <div className="cost_unit">
//                       <input
//                         id="destNonBillTimeHrs"
//                         type="number"
//                         min="0"
//                         step="0.01"
//                         placeholder="0"
//                         value={form.destNonBillTimeHrs || ""}
//                         readOnly
//                       />
//                       <span>hrs</span>
//                     </div>
//                     <div className="cost_hint">Fetched from Google Maps</div>
//                   </div>
//                   <div>
//                     <label htmlFor="destLoadTimeHrs">Loading Time</label>
//                     <div className="cost_unit">
//                       <input
//                         id="destLoadTimeHrs"
//                         type="number"
//                         min="0"
//                         step="0.01"
//                         placeholder="0"
//                         value={form.destLoadTimeHrs || ""}
//                         readOnly
//                       />
//                       <span>hrs</span>
//                     </div>
//                     <div className="cost_hint">Capacity baseline: 650 lbs/hr by 2 men (scaled)</div>
//                   </div>
//                   <div>
//                     <label htmlFor="destUnloadTimeHrs">Unloading Time</label>
//                     <div className="cost_unit">
//                       <input
//                         id="destUnloadTimeHrs"
//                         type="number"
//                         min="0"
//                         step="0.01"
//                         placeholder="0"
//                         value={form.destUnloadTimeHrs || ""}
//                         readOnly
//                       />
//                       <span>hrs</span>
//                     </div>
//                     <div className="cost_hint">Capacity baseline: 850 lbs/hr by 2 men (scaled)</div>
//                   </div>
//                   <div>
//                     <label htmlFor="destUnloadTrailerTimeHrs">Unloading Time (from Trailer)</label>
//                     <div className="cost_unit">
//                       <input
//                         id="destUnloadTrailerTimeHrs"
//                         type="number"
//                         min="0"
//                         step="0.01"
//                         placeholder="0"
//                         value={form.destUnloadTrailerTimeHrs || ""}
//                         readOnly
//                       />
//                       <span>hrs</span>
//                     </div>
//                     <div className="cost_hint">Additional unload at Destination Hub from trailer</div>
//                   </div>
//                   <div>
//                     <label htmlFor="destDriverCost">Driver Cost</label>
//                     <div className="cost_unit">
//                       <input
//                         id="destDriverCost"
//                         type="number"
//                         min="0"
//                         step="0.01"
//                         placeholder="0"
//                         value={form.destDriverCost || ""}
//                         readOnly
//                       />
//                       <span>$</span>
//                     </div>
//                     <div className="cost_hint">(Billable + Non-billable + Load + Unload + Unload from Trailer) × $20</div>
//                   </div>
//                   <div>
//                     <label htmlFor="destHelpersCost">Helpers Cost</label>
//                     <div className="cost_unit">
//                       <input
//                         id="destHelpersCost"
//                         type="number"
//                         min="0"
//                         step="0.01"
//                         placeholder="0"
//                         value={form.destHelpersCost || ""}
//                         readOnly
//                       />
//                       <span>$</span>
//                     </div>
//                     <div className="cost_hint">Per helper: ((All load/unload) × $20 + (Travel × $10)) × helpers</div>
//                   </div>
//                   <div>
//                     <label htmlFor="destTotalLabour">Total Labour Cost</label>
//                     <div className="cost_unit">
//                       <input
//                         id="destTotalLabour"
//                         type="number"
//                         min="0"
//                         step="0.01"
//                         placeholder="0"
//                         value={form.destTotalLabour || ""}
//                         readOnly
//                       />
//                       <span>$</span>
//                     </div>
//                   </div>
//                   <div>
//                     <label htmlFor="destTruckCost">Truck Cost</label>
//                     <div className="cost_unit">
//                       <input
//                         id="destTruckCost"
//                         type="number"
//                         min="0"
//                         step="0.01"
//                         placeholder="0"
//                         value={form.destTruckCost || ""}
//                         readOnly
//                       />
//                       <span>$</span>
//                     </div>
//                     <div className="cost_hint">From Truck Cost above</div>
//                   </div>
//                   <div>
//                     <label htmlFor="destFuelCost">Fuel Cost (Destination)</label>
//                     <div className="cost_unit">
//                       <input
//                         id="destFuelCost"
//                         type="number"
//                         min="0"
//                         step="0.01"
//                         placeholder="0"
//                         value={form.destFuelCost || ""}
//                         readOnly
//                       />
//                       <span>$</span>
//                     </div>
//                     <div className="cost_hint">Formula: ((Destination→Stop + Stop→Destination) ÷ 3.5) × 1.7</div>
//                   </div>
//                   <div>
//                     <label htmlFor="destSubtotal">Subtotal (Destination Side)</label>
//                     <div className="cost_unit">
//                       <input
//                         id="destSubtotal"
//                         type="number"
//                         min="0"
//                         step="0.01"
//                         placeholder="0"
//                         value={form.destSubtotal || ""}
//                         readOnly
//                       />
//                       <span>$</span>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}
//         </section>

//         <section className="cost_card">
//           <div className="cost_row" style={{ justifyContent: "space-between" }}>
//             <h2 style={{ margin: 0, fontSize: "1.05rem" }}>Results</h2>
//           </div>
//           <div className="cost_bar"></div>
//           {!collapsedSections.results && (
//             <>
//               <div className="cost_btns">
//                 <button onClick={reset}>Reset</button>
//               </div>
//               <div className="cost_grid cost_cols-2">
//                 <div className="cost_out">
//                   <div className="cost_hint">Estimated Total</div>
//                   <div className="cost_tot" id="totalCostDisplay">{fmtMoney(totalCost)}</div>
//                   <div className="cost_note">Live formulas based on your rules.</div>
//                 </div>
//                 <div className="cost_out">
//                   <div className="cost_hint">Breakdown</div>
//                   <pre style={{ whiteSpace: "pre-wrap", margin: 0 }}>{breakdown}</pre>
//                 </div>
//               </div>
//             </>
//           )}
//         </section>
//       </main>
//     </div>
//   );
// };

// export default LongMoveCostCalculator;

import React, { useState, useEffect } from "react";
import './CostCalculator.css';

const LongMoveCostCalculator = ({ booking }) => {
  const MOVE_WEIGHT = {
    studio: 1500,
    "1br": 2500,
    "2br": 4000,
    "3br": 6000,
    "4br": 8000,
  };

  const MOVE_TRUCK = {
    studio: "16 ft",
    "1br": "16–20 ft",
    "2br": "20–22 ft",
    "3br": "26 ft",
    "4br": "26+ ft / 5-ton",
  };

  const hubs = [
    { value: "", label: "" },
    { value: "43.6532,-79.3832", label: "Toronto Hub" },
    { value: "49.2827,-123.1207", label: "Vancouver Hub" },
    { value: "51.0447,-114.0719", label: "Calgary Hub" },
  ];

  const moveSizes = [
    { value: "", label: "Select size…" },
    { value: "studio", label: "Studio" },
    { value: "1br", label: "1 Bedroom" },
    { value: "2br", label: "2 Bedroom" },
    { value: "3br", label: "3 Bedroom" },
    { value: "4br", label: "4 Bedroom" },
  ];

  const normalizeMoveSize = (moveSize) => {
    const moveSizeMap = {
      Studio: "studio",
      "1 Bedroom": "1br",
      "2 Bedroom": "2br",
      "3 Bedroom": "3br",
      "4 Bedroom": "4br",
    };
    return moveSizeMap[moveSize] || moveSize.toLowerCase();
  };

  const parseMoveSize = (input) => {
    if (!input) return { moveSize: "", weight: "" };
    const match = input.match(/(.*?)(\d+)\s*lbs$/i);
    if (match) {
      const rawSize = match[1].trim();
      const weight = match[2];
      const normalizedSize = normalizeMoveSize(rawSize);
      return { moveSize: normalizedSize, weight };
    } else {
      return { moveSize: normalizeMoveSize(input), weight: "" };
    }
  };

  const getStaircaseFee = (stairs) => {
    if (stairs >= 40) return 600;
    if (stairs >= 30 && stairs < 40) return 450;
    if (stairs >= 20 && stairs < 30) return 300;
    if (stairs >= 10 && stairs < 20) return 150;
    return 0;
  };

  const getLongWalkCharges = (yards) => {
    if (yards >= 150) return 300;
    if (yards >= 100 && yards < 150) return 250;
    if (yards >= 50 && yards < 100) return 200;
    if (yards >= 40 && yards < 50) return 150;
    return 0;
  };

  const [form, setForm] = useState({
    startingHub: "",
    moveDate: booking?.Move_Date || "",
    origin: booking?.FromAddress || booking?.OriginCity || "",
    destination: booking?.ToAddress || booking?.DestinationCity || "",
    staircaseFee: "",
    longWalkCharges: "",
    stopHub: "",
    km1: "", // Start → Origin
    km2: "", // Origin → Start
    km3: "", // Destination → Stop
    km4: "", // Stop → Destination
    origBillTimeHrs: "",
    origNonBillTimeHrs: "",
    origLoadTimeHrs: "",
    origUnloadTimeHrs: "",
    origLoadTrailerTimeHrs: "",
    destBillTimeHrs: "",
    destNonBillTimeHrs: "",
    destLoadTimeHrs: "",
    destUnloadTimeHrs: "",
    destUnloadTrailerTimeHrs: "",
    origDriverCost: "",
    origHelpersCost: "",
    origTotalLabour: "",
    origTruckCost: "",
    origFuelCost: "",
    origSubtotal: "",
    transTrailerCost: "",
    transSubtotal: "",
    destDriverCost: "",
    destHelpersCost: "",
    destTotalLabour: "",
    destTruckCost: "",
    destFuelCost: "",
    destSubtotal: "",
    moveSize: "",
    estWeightLbs: "",
    truckSize: "",
    numMen: "2",
    truckCost: "200",
    subTotal: "",
    leadCost: "0",
    opsExpense: "0",
    profitPct: "50",
    ACVLSplitPct: "50",
    vendorsplitPct: "50",
  });

  const [distanceStatus, setDistanceStatus] = useState(
    "Enter all locations to fetch distances and times."
  );
  const [totalCost, setTotalCost] = useState(0);
  const [breakdown, setBreakdown] = useState("");
  const [apiKey, setApiKey] = useState("");
  const [isDistanceFetched, setIsDistanceFetched] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [collapsedSections, setCollapsedSections] = useState({
    jobDetails: true,
    moveDetails: true,
    distanceCost: true,
    results: false,
  });

  useEffect(() => {
    const fetchApiKey = async () => {
      try {
        const response = await fetch("https://salesjet-10097049716.catalystappsail.com/api/get-google-api-key");
        const data = await response.json();
        setApiKey(data.apiKey);
      } catch (error) {
        console.error("Failed to fetch API key:", error);
        setDistanceStatus("Error fetching API key.");
      }
    };

    fetchApiKey();

    const { moveSize: normalizedMoveSize, weight } = parseMoveSize(booking?.Move_Size);
    const totalStairs = parseInt(booking?.NoOfStaircasesAtOrigin || 0) + parseInt(booking?.NoOfStaircasesAtDestination || 0);
    const staircaseFee = getStaircaseFee(totalStairs);
    const totalYards = parseFloat(booking?.LongWalkAtOrigin || 0) + parseFloat(booking?.LongWalkAtDestination || 0);
    const longWalkCharges = getLongWalkCharges(totalYards);
    const updates = {
      origin: booking?.FromAddress || booking?.OriginCity || "",
      destination: booking?.ToAddress || booking?.DestinationCity || "",
      moveSize: normalizedMoveSize,
      estWeightLbs: weight || (normalizedMoveSize ? MOVE_WEIGHT[normalizedMoveSize] || "" : ""),
      truckSize: normalizedMoveSize ? MOVE_TRUCK[normalizedMoveSize] || "" : "",
      staircaseFee: staircaseFee.toFixed(2),
      longWalkCharges: longWalkCharges.toFixed(2),
      origTruckCost: "200",
      destTruckCost: "200",
    };
    setForm((prev) => ({ ...prev, ...updates }));
    if (normalizedMoveSize || weight) {
      calculate();
    }
  }, [booking]);

  useEffect(() => {
    if (
      form.km1 ||
      form.km2 ||
      form.km3 ||
      form.km4 ||
      form.origBillTimeHrs ||
      form.origNonBillTimeHrs ||
      form.destBillTimeHrs ||
      form.destNonBillTimeHrs ||
      form.estWeightLbs ||
      form.numMen ||
      form.truckCost ||
      form.profitPct ||
      form.ACVLSplitPct ||
      form.staircaseFee ||
      form.longWalkCharges
    ) {
      calculate();
    }
  }, [
    form.km1,
    form.km2,
    form.km3,
    form.km4,
    form.origBillTimeHrs,
    form.origNonBillTimeHrs,
    form.destBillTimeHrs,
    form.destNonBillTimeHrs,
    form.estWeightLbs,
    form.numMen,
    form.truckCost,
    form.profitPct,
    form.ACVLSplitPct,
    form.staircaseFee,
    form.longWalkCharges,
  ]);

  const fmtMoney = (v) =>
    isFinite(v) ? (v < 0 ? "-$" : "$") + Math.abs(v).toFixed(2) : "$0.00";

  const updateForm = (updates) => {
    setForm((prev) => {
      const newForm = { ...prev, ...updates };
      if (updates.ACVLSplitPct !== undefined) {
        newForm.vendorsplitPct = (100 - parseFloat(updates.ACVLSplitPct || 0)).toString();
      }
      return newForm;
    });
  };

  const calculate = () => {
    const w = parseFloat(form.estWeightLbs) || 0;
    const men = Math.max(1, parseInt(form.numMen || 0));
    const crewFactor = men / 2;
    const km1 = parseFloat(form.km1) || 0;
    const km2 = parseFloat(form.km2) || 0;
    const km3 = parseFloat(form.km3) || 0;
    const km4 = parseFloat(form.km4) || 0;
    const truckCost = parseFloat(form.truckCost) || 200;
    const origBillTime = parseFloat(form.origBillTimeHrs) || 0;
    const origNonBillTime = parseFloat(form.origNonBillTimeHrs) || 0;
    const destBillTime = parseFloat(form.destBillTimeHrs) || 0;
    const destNonBillTime = parseFloat(form.destNonBillTimeHrs) || 0;
    const staircaseFee = parseFloat(form.staircaseFee) || 0;
    const longWalkCharges = parseFloat(form.longWalkCharges) || 0;

    // Origin Side Calculations
    const origLoadTime = crewFactor > 0 ? w / (650 * crewFactor) : 0;
    const origUnloadTime = crewFactor > 0 ? w / (850 * crewFactor) : 0;
    const origLoadTrailerTime = crewFactor > 0 ? w / (650 * crewFactor) : 0;
    const origDriverCost = (origBillTime + origNonBillTime + origLoadTime + origUnloadTime + origLoadTrailerTime) * 20;
    const origHelpers = Math.max(0, men - 1);
    const origHelperPer = (origLoadTime + origUnloadTime + origLoadTrailerTime) * 20 + (origBillTime + origNonBillTime) * 10;
    const origHelpersCost = origHelpers * origHelperPer;
    const origTotalLabour = origDriverCost + origHelpersCost;
    const origFuelCost = ((km1 + km2) / 3.5) * 1.7;
    const origSubtotal = origTotalLabour + truckCost + origFuelCost;

    // Transit Calculations
    const transTrailerCost = w * 0.55;
    const transSubtotal = transTrailerCost;

    // Destination Side Calculations
    const destLoadTime = crewFactor > 0 ? w / (650 * crewFactor) : 0;
    const destUnloadTime = crewFactor > 0 ? w / (850 * crewFactor) : 0;
    const destUnloadTrailerTime = crewFactor > 0 ? w / (850 * crewFactor) : 0;
    const destDriverCost = (destBillTime + destNonBillTime + destLoadTime + destUnloadTime + destUnloadTrailerTime) * 20;
    const destHelpers = Math.max(0, men - 1);
    const destHelperPer = (destLoadTime + destUnloadTime + destUnloadTrailerTime) * 20 + (destBillTime + destNonBillTime) * 10;
    const destHelpersCost = destHelpers * destHelperPer;
    const destTotalLabour = destDriverCost + destHelpersCost;
    const destFuelCost = ((km3 + km4) / 3.5) * 1.7;
    const destSubtotal = destTotalLabour + truckCost + destFuelCost;

    // Fixed Costs
    const subTotal = origSubtotal + transSubtotal + destSubtotal + staircaseFee + longWalkCharges;
    const leadCost = subTotal * 0.05;
    const opsExpense = subTotal * 0.10;
    const profitPct = (parseFloat(form.profitPct) || 0) / 100;
    const acvlSplitPct = (parseFloat(form.ACVLSplitPct) || 0) / 100;
    const vendorSplitPct = (parseFloat(form.vendorsplitPct) || 0) / 100;
    const profitBase = subTotal + leadCost + opsExpense;
    const profit = profitBase * profitPct;
    const total = profitBase + profit;
    const acvlProfit = profit * acvlSplitPct;
    const vendorProfit = profit * vendorSplitPct;

    updateForm({
      origLoadTimeHrs: origLoadTime.toFixed(2),
      origUnloadTimeHrs: origUnloadTime.toFixed(2),
      origLoadTrailerTimeHrs: origLoadTrailerTime.toFixed(2),
      origDriverCost: origDriverCost.toFixed(2),
      origHelpersCost: origHelpersCost.toFixed(2),
      origTotalLabour: origTotalLabour.toFixed(2),
      origTruckCost: truckCost.toFixed(2),
      origFuelCost: origFuelCost.toFixed(2),
      origSubtotal: origSubtotal.toFixed(2),
      transTrailerCost: transTrailerCost.toFixed(2),
      transSubtotal: transSubtotal.toFixed(2),
      destLoadTimeHrs: destLoadTime.toFixed(2),
      destUnloadTimeHrs: destUnloadTime.toFixed(2),
      destUnloadTrailerTimeHrs: destUnloadTrailerTime.toFixed(2),
      destDriverCost: destDriverCost.toFixed(2),
      destHelpersCost: destHelpersCost.toFixed(2),
      destTotalLabour: destTotalLabour.toFixed(2),
      destTruckCost: truckCost.toFixed(2),
      destFuelCost: destFuelCost.toFixed(2),
      destSubtotal: destSubtotal.toFixed(2),
      subTotal: subTotal.toFixed(2),
      leadCost: leadCost.toFixed(2),
      opsExpense: opsExpense.toFixed(2),
    });

    setTotalCost(total);
    setBreakdown(
      `Origin Side:
  Billable Travel Time: ${origBillTime.toFixed(2)} hrs
  Non-Billable Travel Time: ${origNonBillTime.toFixed(2)} hrs
  Loading: ${origLoadTime.toFixed(2)} hrs
  Unloading: ${origUnloadTime.toFixed(2)} hrs
  Loading into Trailer: ${origLoadTrailerTime.toFixed(2)} hrs
  Driver: ${fmtMoney(origDriverCost)}
  Helpers: ${fmtMoney(origHelpersCost)}
  Truck: ${fmtMoney(truckCost)}
  Fuel: ${fmtMoney(origFuelCost)}
  Subtotal (Origin): ${fmtMoney(origSubtotal)}
Transit:
  Trailer Transit: ${fmtMoney(transTrailerCost)}
  Subtotal (Transit): ${fmtMoney(transSubtotal)}
Destination Side:
  Billable Travel Time: ${destBillTime.toFixed(2)} hrs
  Non-Billable Travel Time: ${destNonBillTime.toFixed(2)} hrs
  Loading: ${destLoadTime.toFixed(2)} hrs
  Unloading: ${destUnloadTime.toFixed(2)} hrs
  Unloading from Trailer: ${destUnloadTrailerTime.toFixed(2)} hrs
  Driver: ${fmtMoney(destDriverCost)}
  Helpers: ${fmtMoney(destHelpersCost)}
  Truck: ${fmtMoney(truckCost)}
  Fuel: ${fmtMoney(destFuelCost)}
  Subtotal (Dest): ${fmtMoney(destSubtotal)}
Totals:
  Local Labour (Origin+Dest): ${fmtMoney(origTotalLabour + destTotalLabour)}
  Total Fuel: ${fmtMoney(origFuelCost + destFuelCost)}
  Trailer Transit: ${fmtMoney(transTrailerCost)}
  Stairs: ${fmtMoney(staircaseFee)}
  Long Walk: ${fmtMoney(longWalkCharges)}
  SubTotal: ${fmtMoney(subTotal)}
  Lead (5%): ${fmtMoney(leadCost)}
  Ops (10%): ${fmtMoney(opsExpense)}
  Profit (${form.profitPct || 0}%): ${fmtMoney(profit)}
    ACVL (${form.ACVLSplitPct || 0}%): ${fmtMoney(acvlProfit)}
    Vendor (${form.vendorsplitPct || 0}%): ${fmtMoney(vendorProfit)}
Grand Total: ${fmtMoney(total)}`
    );
  };

  const fetchDistances = async () => {
    setDistanceStatus('Looking up distances and times…');
    setIsFetching(true);
    setIsDistanceFetched(false);
    try {
      const { startingHub, stopHub, origin, destination } = form;
      if (!(startingHub && stopHub && origin && destination)) {
        setDistanceStatus('Please fill Starting Hub, Stop Hub, Origin, and Destination.');
        setIsFetching(false);
        return;
      }

      const response = await fetch('https://salesjet-10097049716.catalystappsail.com/api/long-calculate-distances', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ startingHub, stopHub, origin, destination }),
      });

      if (!response.ok) {
        throw new Error('Failed to fetch distances from server.');
      }

      const {
        km1,
        km2,
        km3,
        km4,
        billableKm,
        origBillTimeHrs,
        origNonBillTimeHrs,
        destBillTimeHrs,
        destNonBillTimeHrs,
        billableTimeHrs,
      } = await response.json();

      console.log('Fetched data:', {
        km1,
        km2,
        km3,
        km4,
        billableKm,
        origBillTimeHrs,
        origNonBillTimeHrs,
        destBillTimeHrs,
        destNonBillTimeHrs,
        billableTimeHrs,
      });

      updateForm({
        km1,
        km2,
        km3,
        km4,
        origBillTimeHrs,
        origNonBillTimeHrs,
        destBillTimeHrs,
        destNonBillTimeHrs,
      });

      setTimeout(() => calculate(), 0); // Ensure updateForm completes
      setIsDistanceFetched(true);
      setDistanceStatus(
        `Updated ✓ Legs: ${km1} km (${origBillTimeHrs} hrs), ${km2} km (${origNonBillTimeHrs} hrs), ${km3} km (${destBillTimeHrs} hrs), ${km4} km (${destNonBillTimeHrs} hrs) | Billable: ${billableKm} km (${billableTimeHrs} hrs)`
      );
    } catch (err) {
      console.error(err);
      setDistanceStatus('Distance and time lookup failed. Check locations or try again.');
      setIsDistanceFetched(false);
    } finally {
      setIsFetching(false);
    }
  };

  const reset = () => {
    const { moveSize: normalizedMoveSize, weight } = parseMoveSize(booking?.Move_Size);
    const totalStairs = parseInt(booking?.NoOfStaircasesAtOrigin || 0) + parseInt(booking?.NoOfStaircasesAtDestination || 0);
    const staircaseFee = getStaircaseFee(totalStairs);
    const totalYards = parseFloat(booking?.LongWalkAtOrigin || 0) + parseFloat(booking?.LongWalkAtDestination || 0);
    const longWalkCharges = getLongWalkCharges(totalYards);
    setForm({
      startingHub: "",
      moveDate: booking?.Move_Date || "",
      origin: booking?.FromAddress || booking?.OriginCity || "",
      destination: booking?.ToAddress || booking?.DestinationCity || "",
      stopHub: "",
      km1: "",
      km2: "",
      km3: "",
      km4: "",
      origBillTimeHrs: "",
      origNonBillTimeHrs: "",
      origLoadTimeHrs: "",
      origUnloadTimeHrs: "",
      origLoadTrailerTimeHrs: "",
      destBillTimeHrs: "",
      destNonBillTimeHrs: "",
      destLoadTimeHrs: "",
      destUnloadTimeHrs: "",
      destUnloadTrailerTimeHrs: "",
      origDriverCost: "",
      origHelpersCost: "",
      origTotalLabour: "",
      origTruckCost: "200",
      origFuelCost: "",
      origSubtotal: "",
      transTrailerCost: "",
      transSubtotal: "",
      destDriverCost: "",
      destHelpersCost: "",
      destTotalLabour: "",
      destTruckCost: "200",
      destFuelCost: "",
      destSubtotal: "",
      moveSize: normalizedMoveSize,
      estWeightLbs: weight || (normalizedMoveSize ? MOVE_WEIGHT[normalizedMoveSize] || "" : ""),
      truckSize: normalizedMoveSize ? MOVE_TRUCK[normalizedMoveSize] || "" : "",
      numMen: "2",
      truckCost: "200",
      subTotal: "",
      leadCost: "0",
      opsExpense: "0",
      profitPct: "50",
      ACVLSplitPct: "50",
      vendorsplitPct: "50",
      staircaseFee: staircaseFee.toFixed(2),
      longWalkCharges: longWalkCharges.toFixed(2),
    });
    setDistanceStatus("Enter all locations to fetch distances and times.");
    setTotalCost(0);
    setBreakdown("");
    setIsDistanceFetched(false);
    setIsFetching(false);
    setCollapsedSections({
      jobDetails: false,
      moveDetails: false,
      distanceCost: false,
      results: false,
    });
  };

  const toggleSection = (section) => {
    setCollapsedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const SelectField = ({ id, label, options, hint, onChange }) => (
    <div>
      <label htmlFor={id}>{label}</label>
      <select
        id={id}
        value={form[id] || ""}
        onChange={onChange || ((e) => updateForm({ [id]: e.target.value }))}
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
      {hint && <div className="cost_hint">{hint}</div>}
    </div>
  );

  const ComboField = ({ id, label, options, hint, onFieldUpdate }) => {
    const getDisplayValue = (storedValue) => {
      const matchedOption = options.find((opt) => opt.value === storedValue);
      return matchedOption ? matchedOption.label : storedValue;
    };

    const [inputValue, setInputValue] = useState(getDisplayValue(form[id] || ""));

    useEffect(() => {
      setInputValue(getDisplayValue(form[id] || ""));
    }, [form[id], id, options]);

    const handleChange = (e) => {
      setInputValue(e.target.value);
    };

    const handleBlur = () => {
      const matchedOption = options.find((opt) => opt.label === inputValue);
      const finalValue = matchedOption ? matchedOption.value : inputValue;
      updateForm({ [id]: finalValue });
      if (onFieldUpdate) {
        onFieldUpdate(finalValue);
      }
    };

    const handleFocus = (e) => {
      e.target.select();
    };

    return (
      <div>
        <label htmlFor={id}>{label}</label>
        <input
          id={id}
          type="text"
          list={`${id}-datalist`}
          value={inputValue}
          onChange={handleChange}
          onBlur={handleBlur}
          onFocus={handleFocus}
          placeholder="Type location or select hub..."
        />
        <datalist id={`${id}-datalist`}>
          {options.map((opt) => (
            <option key={opt.value} value={opt.label}>
              {opt.label}
            </option>
          ))}
        </datalist>
        {hint && <div className="cost_hint">{hint}</div>}
      </div>
    );
  };

  return (
    <div className="cost_wrap">
      <main className="cost_wrap">
        <section className="cost_card">
          <div className="cost_row" style={{ justifyContent: "space-between" }}>
            <h2 style={{ margin: 0, fontSize: "1.05rem" }}>Job Details</h2>
            <div style={{ display: "flex", alignItems: "center" }}>
              <span className="cost_pill">All distances in KM • Times from Google Maps</span>
              <button
                onClick={() => toggleSection("jobDetails")}
                style={{
                  marginLeft: "10px",
                  fontSize: "1.2rem",
                  cursor: "pointer",
                  color: "#333",
                  border: "none",
                  background: "none",
                }}
              >
                {collapsedSections.jobDetails ? "+" : "−"}
              </button>
            </div>
          </div>
          <div className="cost_bar"></div>
          {!collapsedSections.jobDetails && (
            <div className="cost_grid cost_cols-3">
              <div>
                <label htmlFor="origin">Origin (City, Province)</label>
                <div className="cost_unit">
                  <input
                    id="origin"
                    type="text"
                    placeholder="City, ST, Country or lat,lon"
                    value={form.origin || ""}
                    onChange={(e) => updateForm({ origin: e.target.value })}
                  />
                </div>
              </div>
              <div>
                <label htmlFor="destination">Destination (City, Province)</label>
                <div className="cost_unit">
                  <input
                    id="destination"
                    type="text"
                    placeholder="City, ST, Country or lat,lon"
                    value={form.destination || ""}
                    onChange={(e) => updateForm({ destination: e.target.value })}
                  />
                </div>
              </div>
              <div>
                <label htmlFor="moveDate">Move Date</label>
                <div className="cost_unit">
                  <input
                    id="moveDate"
                    type="text"
                    placeholder="YYYY-MM-DD"
                    value={form.moveDate || ""}
                    onChange={(e) => updateForm({ moveDate: e.target.value })}
                  />
                </div>
              </div>
              <div>
                <label htmlFor="moveSize">Move Size (Bedrooms)</label>
                <div className="cost_unit">
                  <input
                    id="moveSize"
                    type="text"
                    placeholder="Select size…"
                    value={moveSizes.find(opt => opt.value === form.moveSize)?.label || form.moveSize || ""}
                    readOnly
                  />
                </div>
              </div>
            </div>
          )}
        </section>

        <section className="cost_card">
          <div className="cost_row" style={{ justifyContent: "space-between" }}>
            <h2 style={{ margin: 0, fontSize: "1.05rem" }}>Move Details & Profit Range</h2>
            <button
              onClick={() => toggleSection("moveDetails")}
              style={{
                fontSize: "1.2rem",
                cursor: "pointer",
                color: "#333",
                border: "none",
                background: "none",
              }}
            >
              {collapsedSections.moveDetails ? "+" : "−"}
            </button>
          </div>
          <div className="cost_bar"></div>
          {!collapsedSections.moveDetails && (
            <>
              <div className="cost_grid cost_cols-3">
                <ComboField
                  id="startingHub"
                  label="Starting Location (Hub)"
                  options={hubs}
                  onFieldUpdate={(value) => {
                    if (form.stopHub && value) {
                      fetchDistances();
                    }
                  }}
                />
                <ComboField
                  id="stopHub"
                  label="Stop Location (Hub)"
                  options={hubs}
                  onFieldUpdate={(value) => {
                    if (form.startingHub && value) {
                      fetchDistances();
                    }
                  }}
                />
              </div>
              <div className="cost_btns" style={{ marginTop: "8px", position: "relative" }}>
                <button
                  type="button"
                  onClick={fetchDistances}
                  className={isDistanceFetched ? "cost_fetched" : isFetching ? "cost_fetching" : ""}
                >
                  Fetch distances and times (Google Maps)
                  {isFetching && (
                    <span className="spinner" style={{ marginLeft: "8px" }}>↻</span>
                  )}
                </button>
              </div>
              <div className="cost_grid cost_cols-3" style={{ marginTop: "10px" }}>
                <div>
                  <label htmlFor="estWeightLbs">Estimated Weight</label>
                  <div className="cost_unit">
                    <input
                      id="estWeightLbs"
                      type="number"
                      min="0"
                      step="1"
                      placeholder="0"
                      value={form.estWeightLbs || ""}
                      onChange={(e) => {
                        updateForm({ estWeightLbs: e.target.value });
                        calculate();
                      }}
                    />
                    <span>lbs</span>
                  </div>
                </div>
                <div>
                  <label htmlFor="truckSize">Truck Size</label>
                  <div className="cost_unit">
                    <input
                      id="truckSize"
                      type="text"
                      placeholder="e.g., 16 ft / 20 ft / 26 ft"
                      value={form.truckSize || ""}
                      onChange={(e) => updateForm({ truckSize: e.target.value })}
                    />
                  </div>
                </div>
                <div>
                  <label htmlFor="numMen">Number of Men</label>
                  <div className="cost_unit">
                    <input
                      id="numMen"
                      type="number"
                      min="1"
                      step="1"
                      placeholder="2"
                      value={form.numMen || ""}
                      onChange={(e) => {
                        updateForm({ numMen: e.target.value });
                        calculate();
                      }}
                    />
                  </div>
                </div>
                <div>
                  <label htmlFor="truckCost">Truck Cost</label>
                  <div className="cost_unit">
                    <input
                      id="truckCost"
                      type="number"
                      min="0"
                      step="0.01"
                      placeholder="200"
                      value={form.truckCost || ""}
                      onChange={(e) => {
                        updateForm({ truckCost: e.target.value, origTruckCost: e.target.value, destTruckCost: e.target.value });
                        calculate();
                      }}
                    />
                    <span>$</span>
                  </div>
                  <div className="cost_hint">Enter truck rental or usage cost manually.</div>
                </div>
                <div>
                  <label htmlFor="profitPct">Profit Percentage</label>
                  <div className="cost_unit">
                    <input
                      id="profitPct"
                      type="number"
                      min="0"
                      step="0.1"
                      placeholder="50"
                      value={form.profitPct || ""}
                      onChange={(e) => {
                        updateForm({ profitPct: e.target.value });
                      }}
                    />
                    <span>%</span>
                  </div>
                  <div className="cost_hint">Applied to (Sub-Total + Lead + Ops)</div>
                </div>
                <div>
                  <label htmlFor="ACVLSplitPct">ACVL Profit Split</label>
                  <div className="cost_unit">
                    <input
                      id="ACVLSplitPct"
                      type="number"
                      min="0"
                      max="100"
                      step="0.1"
                      placeholder="50"
                      value={form.ACVLSplitPct || ""}
                      onChange={(e) => {
                        updateForm({ ACVLSplitPct: e.target.value });
                      }}
                    />
                    <span>%</span>
                  </div>
                </div>
                <div>
                  <label htmlFor="vendorsplitPct">Vendor Profit Split</label>
                  <div className="cost_unit">
                    <input
                      id="vendorsplitPct"
                      type="number"
                      min="0"
                      max="100"
                      step="0.1"
                      placeholder="50"
                      value={form.vendorsplitPct || ""}
                      readOnly
                    />
                    <span>%</span>
                  </div>
                </div>
              </div>
            </>
          )}
        </section>

        <section className="cost_card">
          <div className="cost_row" style={{ justifyContent: "space-between" }}>
            <h2 style={{ margin: 0, fontSize: "1.05rem" }}>Detailed Cost Breakdown</h2>
            <button
              onClick={() => toggleSection("distanceCost")}
              style={{
                fontSize: "1.2rem",
                cursor: "pointer",
                border: "none",
                color: "#333",
                background: "none",
              }}
            >
              {collapsedSections.distanceCost ? "+" : "−"}
            </button>
          </div>
          <div className="cost_bar"></div>
          {!collapsedSections.distanceCost && (
            <div>
              {/* Origin Side */}
              <div style={{ marginBottom: "12px" }}>
                <h5 style={{ margin: "0.2rem 0" }}>Origin Side Cost</h5>
                <div className="cost_bar"></div>
                <div className="cost_grid cost_cols-3">
                  <div>
                    <label htmlFor="km1">Start → Origin (km)</label>
                    <div className="cost_unit">
                      <input
                        id="km1"
                        type="number"
                        min="0"
                        step="0.1"
                        placeholder="0"
                        value={form.km1 || ""}
                        onChange={(e) => {
                          updateForm({ km1: e.target.value });
                          calculate();
                        }}
                      />
                      <span>km</span>
                    </div>
                  </div>
                  <div>
                    <label htmlFor="km2">Origin → Start (km)</label>
                    <div className="cost_unit">
                      <input
                        id="km2"
                        type="number"
                        min="0"
                        step="0.1"
                        placeholder="0"
                        value={form.km2 || ""}
                        onChange={(e) => {
                          updateForm({ km2: e.target.value });
                          calculate();
                        }}
                      />
                      <span>km</span>
                    </div>
                  </div>
                  <div>
                    <label htmlFor="origBillTimeHrs">Billable Travel Time</label>
                    <div className="cost_unit">
                      <input
                        id="origBillTimeHrs"
                        type="number"
                        min="0"
                        step="0.01"
                        placeholder="0"
                        value={form.origBillTimeHrs || ""}
                        readOnly
                      />
                      <span>hrs</span>
                    </div>
                    <div className="cost_hint">Fetched from Google Maps</div>
                  </div>
                  <div>
                    <label htmlFor="origNonBillTimeHrs">Non-Billable Travel Time</label>
                    <div className="cost_unit">
                      <input
                        id="origNonBillTimeHrs"
                        type="number"
                        min="0"
                        step="0.01"
                        placeholder="0"
                        value={form.origNonBillTimeHrs || ""}
                        readOnly
                      />
                      <span>hrs</span>
                    </div>
                    <div className="cost_hint">Fetched from Google Maps</div>
                  </div>
                  <div>
                    <label htmlFor="origLoadTimeHrs">Loading Time</label>
                    <div className="cost_unit">
                      <input
                        id="origLoadTimeHrs"
                        type="number"
                        min="0"
                        step="0.01"
                        placeholder="0"
                        value={form.origLoadTimeHrs || ""}
                        readOnly
                      />
                      <span>hrs</span>
                    </div>
                    <div className="cost_hint">Capacity baseline: 650 lbs/hr by 2 men (scaled)</div>
                  </div>
                  <div>
                    <label htmlFor="origUnloadTimeHrs">Unloading Time</label>
                    <div className="cost_unit">
                      <input
                        id="origUnloadTimeHrs"
                        type="number"
                        min="0"
                        step="0.01"
                        placeholder="0"
                        value={form.origUnloadTimeHrs || ""}
                        readOnly
                      />
                      <span>hrs</span>
                    </div>
                    <div className="cost_hint">Capacity baseline: 850 lbs/hr by 2 men (scaled)</div>
                  </div>
                  <div>
                    <label htmlFor="origLoadTrailerTimeHrs">Loading Time (into Trailer)</label>
                    <div className="cost_unit">
                      <input
                        id="origLoadTrailerTimeHrs"
                        type="number"
                        min="0"
                        step="0.01"
                        placeholder="0"
                        value={form.origLoadTrailerTimeHrs || ""}
                        readOnly
                      />
                      <span>hrs</span>
                    </div>
                    <div className="cost_hint">Additional load at Origin Hub into trailer</div>
                  </div>
                  <div>
                    <label htmlFor="origDriverCost">Driver Cost</label>
                    <div className="cost_unit">
                      <input
                        id="origDriverCost"
                        type="number"
                        min="0"
                        step="0.01"
                        placeholder="0"
                        value={form.origDriverCost || ""}
                        readOnly
                      />
                      <span>$</span>
                    </div>
                    <div className="cost_hint">(Billable + Non-billable + Load + Unload + Load into Trailer) × $20</div>
                  </div>
                  <div>
                    <label htmlFor="origHelpersCost">Helpers Cost</label>
                    <div className="cost_unit">
                      <input
                        id="origHelpersCost"
                        type="number"
                        min="0"
                        step="0.01"
                        placeholder="0"
                        value={form.origHelpersCost || ""}
                        readOnly
                      />
                      <span>$</span>
                    </div>
                    <div className="cost_hint">Per helper: ((All load/unload) × $20 + (Travel × $10)) × helpers</div>
                  </div>
                  <div>
                    <label htmlFor="origTotalLabour">Total Labour Cost</label>
                    <div className="cost_unit">
                      <input
                        id="origTotalLabour"
                        type="number"
                        min="0"
                        step="0.01"
                        placeholder="0"
                        value={form.origTotalLabour || ""}
                        readOnly
                      />
                      <span>$</span>
                    </div>
                  </div>
                  <div>
                    <label htmlFor="origTruckCost">Truck Cost</label>
                    <div className="cost_unit">
                      <input
                        id="origTruckCost"
                        type="number"
                        min="0"
                        step="0.01"
                        placeholder="0"
                        value={form.origTruckCost || ""}
                        readOnly
                      />
                      <span>$</span>
                    </div>
                    <div className="cost_hint">From Truck Cost above</div>
                  </div>
                  <div>
                    <label htmlFor="origFuelCost">Fuel Cost (Origin)</label>
                    <div className="cost_unit">
                      <input
                        id="origFuelCost"
                        type="number"
                        min="0"
                        step="0.01"
                        placeholder="0"
                        value={form.origFuelCost || ""}
                        readOnly
                      />
                      <span>$</span>
                    </div>
                    <div className="cost_hint">Formula: ((Start→Origin + Origin→Start) ÷ 3.5) × 1.7</div>
                  </div>
                  <div>
                    <label htmlFor="origSubtotal">Subtotal (Origin Side)</label>
                    <div className="cost_unit">
                      <input
                        id="origSubtotal"
                        type="number"
                        min="0"
                        step="0.01"
                        placeholder="0"
                        value={form.origSubtotal || ""}
                        readOnly
                      />
                      <span>$</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Transit */}
              <div style={{ marginBottom: "12px" }}>
                <h5 style={{ margin: "0.2rem 0" }}>Transit</h5>
                <div className="cost_bar"></div>
                <div className="cost_grid cost_cols-3">
                  <div>
                    <label htmlFor="transTrailerCost">Trailer Transit Cost</label>
                    <div className="cost_unit">
                      <input
                        id="transTrailerCost"
                        type="number"
                        min="0"
                        step="0.01"
                        placeholder="0"
                        value={form.transTrailerCost || ""}
                        readOnly
                      />
                      <span>$</span>
                    </div>
                    <div className="cost_hint">Formula: Weight (lbs) × 0.55</div>
                  </div>
                  <div>
                    <label htmlFor="transSubtotal">Transit Subtotal</label>
                    <div className="cost_unit">
                      <input
                        id="transSubtotal"
                        type="number"
                        min="0"
                        step="0.01"
                        placeholder="0"
                        value={form.transSubtotal || ""}
                        readOnly
                      />
                      <span>$</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Destination Side */}
              <div>
                <h5 style={{ margin: "0.2rem 0" }}>Destination Side Cost</h5>
                <div className="cost_bar"></div>
                <div className="cost_grid cost_cols-3">
                  <div>
                    <label htmlFor="km3">Destination → Stop (km)</label>
                    <div className="cost_unit">
                      <input
                        id="km3"
                        type="number"
                        min="0"
                        step="0.1"
                        placeholder="0"
                        value={form.km3 || ""}
                        onChange={(e) => {
                          updateForm({ km3: e.target.value });
                          calculate();
                        }}
                      />
                      <span>km</span>
                    </div>
                  </div>
                  <div>
                    <label htmlFor="km4">Stop → Destination (km)</label>
                    <div className="cost_unit">
                      <input
                        id="km4"
                        type="number"
                        min="0"
                        step="0.1"
                        placeholder="0"
                        value={form.km4 || ""}
                        onChange={(e) => {
                          updateForm({ km4: e.target.value });
                          calculate();
                        }}
                      />
                      <span>km</span>
                    </div>
                  </div>
                  <div>
                    <label htmlFor="destBillTimeHrs">Billable Travel Time</label>
                    <div className="cost_unit">
                      <input
                        id="destBillTimeHrs"
                        type="number"
                        min="0"
                        step="0.01"
                        placeholder="0"
                        value={form.destBillTimeHrs || ""}
                        readOnly
                      />
                      <span>hrs</span>
                    </div>
                    <div className="cost_hint">Fetched from Google Maps</div>
                  </div>
                  <div>
                    <label htmlFor="destNonBillTimeHrs">Non-Billable Travel Time</label>
                    <div className="cost_unit">
                      <input
                        id="destNonBillTimeHrs"
                        type="number"
                        min="0"
                        step="0.01"
                        placeholder="0"
                        value={form.destNonBillTimeHrs || ""}
                        readOnly
                      />
                      <span>hrs</span>
                    </div>
                    <div className="cost_hint">Fetched from Google Maps</div>
                  </div>
                  <div>
                    <label htmlFor="destLoadTimeHrs">Loading Time</label>
                    <div className="cost_unit">
                      <input
                        id="destLoadTimeHrs"
                        type="number"
                        min="0"
                        step="0.01"
                        placeholder="0"
                        value={form.destLoadTimeHrs || ""}
                        readOnly
                      />
                      <span>hrs</span>
                    </div>
                    <div className="cost_hint">Capacity baseline: 650 lbs/hr by 2 men (scaled)</div>
                  </div>
                  <div>
                    <label htmlFor="destUnloadTimeHrs">Unloading Time</label>
                    <div className="cost_unit">
                      <input
                        id="destUnloadTimeHrs"
                        type="number"
                        min="0"
                        step="0.01"
                        placeholder="0"
                        value={form.destUnloadTimeHrs || ""}
                        readOnly
                      />
                      <span>hrs</span>
                    </div>
                    <div className="cost_hint">Capacity baseline: 850 lbs/hr by 2 men (scaled)</div>
                  </div>
                  <div>
                    <label htmlFor="destUnloadTrailerTimeHrs">Unloading Time (from Trailer)</label>
                    <div className="cost_unit">
                      <input
                        id="destUnloadTrailerTimeHrs"
                        type="number"
                        min="0"
                        step="0.01"
                        placeholder="0"
                        value={form.destUnloadTrailerTimeHrs || ""}
                        readOnly
                      />
                      <span>hrs</span>
                    </div>
                    <div className="cost_hint">Additional unload at Destination Hub from trailer</div>
                  </div>
                  <div>
                    <label htmlFor="destDriverCost">Driver Cost</label>
                    <div className="cost_unit">
                      <input
                        id="destDriverCost"
                        type="number"
                        min="0"
                        step="0.01"
                        placeholder="0"
                        value={form.destDriverCost || ""}
                        readOnly
                      />
                      <span>$</span>
                    </div>
                    <div className="cost_hint">(Billable + Non-billable + Load + Unload + Unload from Trailer) × $20</div>
                  </div>
                  <div>
                    <label htmlFor="destHelpersCost">Helpers Cost</label>
                    <div className="cost_unit">
                      <input
                        id="destHelpersCost"
                        type="number"
                        min="0"
                        step="0.01"
                        placeholder="0"
                        value={form.destHelpersCost || ""}
                        readOnly
                      />
                      <span>$</span>
                    </div>
                    <div className="cost_hint">Per helper: ((All load/unload) × $20 + (Travel × $10)) × helpers</div>
                  </div>
                  <div>
                    <label htmlFor="destTotalLabour">Total Labour Cost</label>
                    <div className="cost_unit">
                      <input
                        id="destTotalLabour"
                        type="number"
                        min="0"
                        step="0.01"
                        placeholder="0"
                        value={form.destTotalLabour || ""}
                        readOnly
                      />
                      <span>$</span>
                    </div>
                  </div>
                  <div>
                    <label htmlFor="destTruckCost">Truck Cost</label>
                    <div className="cost_unit">
                      <input
                        id="destTruckCost"
                        type="number"
                        min="0"
                        step="0.01"
                        placeholder="0"
                        value={form.destTruckCost || ""}
                        readOnly
                      />
                      <span>$</span>
                    </div>
                    <div className="cost_hint">From Truck Cost above</div>
                  </div>
                  <div>
                    <label htmlFor="destFuelCost">Fuel Cost (Destination)</label>
                    <div className="cost_unit">
                      <input
                        id="destFuelCost"
                        type="number"
                        min="0"
                        step="0.01"
                        placeholder="0"
                        value={form.destFuelCost || ""}
                        readOnly
                      />
                      <span>$</span>
                    </div>
                    <div className="cost_hint">Formula: ((Destination→Stop + Stop→Destination) ÷ 3.5) × 1.7</div>
                  </div>
                  <div>
                    <label htmlFor="destSubtotal">Subtotal (Destination Side)</label>
                    <div className="cost_unit">
                      <input
                        id="destSubtotal"
                        type="number"
                        min="0"
                        step="0.01"
                        placeholder="0"
                        value={form.destSubtotal || ""}
                        readOnly
                      />
                      <span>$</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </section>

        <section className="cost_card">
          <div className="cost_row" style={{ justifyContent: "space-between" }}>
            <h2 style={{ margin: 0, fontSize: "1.05rem" }}>Results</h2>
          </div>
          <div className="cost_bar"></div>
          {!collapsedSections.results && (
            <>
              <div className="cost_btns">
                <button onClick={reset}>Reset</button>
              </div>
              <div className="cost_grid cost_cols-2">
                <div className="cost_out">
                  <div className="cost_hint">Estimated Total</div>
                  <div className="cost_tot" id="totalCostDisplay">{fmtMoney(totalCost)}</div>
                  <div className="cost_note">Live formulas based on your rules.</div>
                </div>
                <div className="cost_out">
                  <div className="cost_hint">Breakdown</div>
                  <pre style={{ whiteSpace: "pre-wrap", margin: 0 }}>{breakdown}</pre>
                </div>
              </div>
            </>
          )}
        </section>
      </main>
    </div>
  );
};

export default LongMoveCostCalculator;